<template>
  <div class="dark-theme" style="touch-action: pan-x">
    <div class="loading-page" v-show="loading">
      <div class="loading-gif" id="demoCanvas"></div>
    </div>
    <div id="wow">
      <div class="stage">
        <div class="top">
          <transition enter-active-class="animated fadeInDownBig">
            <div v-if="currentStep == 'clothes'">
              <span class="btn next right" @click="nextStep">下一步</span>
            </div>
          </transition>
          <transition enter-active-class="animated fadeInDownBig">
            <div v-if="currentStep == 'picture' && !isAction">
              <span class="btn next left" @click="$refs.stepConfirmModal.showModal({ type: 0 })">上一步</span>
              <span class="btn next right" @click="exportImage">生成</span>
            </div>
          </transition>
          <transition enter-active-class="animated fadeInDownBig">
            <div v-if="currentStep == 'camera'">
              <span class="btn next left" @click="$refs.stepConfirmModal.showModal({ type: 0 })">上一步</span>
              <span class="btn next right" @click="goShare">分享</span>
            </div>
          </transition>
        </div>
        <div class="editor" ref="editor">
          <!-- <div class="bot-text" v-if="currentStep == 'camera'">
            <img :src="textEditData.botTextImg.list[textEditData.botTextImg.active].img" alt="" srcset="" />
          </div>
          <div class="top-text" v-if="currentStep == 'camera'">
            <img :src="textEditData.topTextImg.list[textEditData.topTextImg.active].img" alt="" srcset="" />
          </div> -->
          <div id="spine"></div>
          <div class="result_box" ref="result_box">
            <div class="result_content">
              <!-- <div class="bg" v-if="dataList.picture.bg.active !== ''">
                <img :src="dataList.picture.bg.list[dataList.picture.bg.active].thumb" alt="" />
              </div>
              <div class="person" v-if="exportImg" :style="{'left': exportPosition.left + 'px', 'top': exportPosition.top + 'px'}">
                <img :src="exportImg" alt="" srcset="" />
              </div> -->
              <img :src="exportImg" alt="" srcset="" />
            </div>
            <div class="bot-info">
              <div class="text">
                <p>长按识别，制作你的二次元角色</p>
              </div>
              <div class="code">
                <img :src="qrCodeUrl" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition enter-active-class="animated fadeInUpBig">
        <div class="action-tab" v-if="currentStep == 'clothes'">
          <div class="main-button" v-if="!showColor">
            <div class="left">
              <span class="btn random-btn" @click="randomClick">
                <i class="icon-icon_cross_dress_16 icon"></i>
                <span>随机变装</span>
              </span>
            </div>
            <div class="right">
              <span
                class="btn default-btn"
                :class="{ disabled: dataList.clothes.my.list.length == 0 }"
                @click="resetClick"
                ><i>默认</i>
              </span>
              <span class="btn prev-btn" :class="{ disabled: historyIndex == -1 }" @click="prevClick">
                <i class="icon-icon_revoke_last_16"></i>
              </span>
              <span
                class="btn next-btn"
                :class="{ disabled: historyIndex + 1 == historyList.length }"
                @click="nextClick"
              >
                <i class="icon-icon_revoke_next_16"></i>
              </span>
            </div>
          </div>
          <div class="action-nav">
            <div class="action-nav-list">
              <div
                class="action-nav-item"
                :class="{ active: activeTab == value.type }"
                v-for="(value, key) in typeMaps"
                :key="key"
              >
                <span :class="[value.icon]" @click="navClick(key)"></span>
              </div>
            </div>
            <div class="jianbian"></div>
          </div>
          <div class="tab-list">
            <div class="tab-item" v-show="activeTab == 'my'" :class="[`my`]">
              <div class="title">当前搭配</div>
              <div class="action-list">
                <div class="action-item" v-for="(item, index) in dataList['clothes']['my'].list" :key="item.type">
                  <div class="cover">
                    <img
                      v-if="item.thumb"
                      :src="constv.QINIU_IMAGE_CND_URL + item.thumb + '?imageView2/2/w/160'"
                      alt=""
                    />
                  </div>
                  <div class="name">
                    <span>
                      {{ typeMaps[item.type] && typeMaps[item.type].text }}
                    </span>
                  </div>
                  <span class="delete-btn" @click="deleteChoose(item, index)">
                    <i class="icon-icon_close_8"></i>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="tab-item"
              v-show="activeTab == type"
              v-for="type in changeTypeList"
              :key="type"
              :class="[`${type}`]"
            >
              <div class="action-list">
                <div
                  class="action-item animated fadeIn"
                  v-for="item in dataList['clothes'][type].list"
                  :key="item.id"
                  @click="choose(item)"
                >
                  <div class="cover" :class="{ active: dataList['clothes'][type].active == item.id }">
                    <img
                      v-if="item.thumb"
                      :src="constv.QINIU_IMAGE_CND_URL + item.thumb + '?imageView2/2/w/160'"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div class="btn color-btn" v-if="type == 'hair' || type == 'eyes'" @click="colorClick">
                <span class="icon-icon_colour_22 icon"></span>
              </div>
            </div>
            <div class="tab-item" v-if="activeTab == 'skin'" :class="[`skin`]">
              <div class="color-list">
                <div
                  class="color-list_slide"
                  v-for="(value, key) in dataList['clothes'].skin.colorInfo.slidePick"
                  :key="key"
                >
                  <div class="color-list_title">{{ value.text }}</div>
                  <div class="color-pick" :class="[`color-${key}`]">
                    <div
                      class="slider"
                      :style="{ left: value.left + '%' }"
                      @touchstart="touchstart($event, key)"
                      @touchmove="touchmove($event, key)"
                      @touchend="touchend($event, key)"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="bot-btn" style="justify-content: center; background-color: #282d40">
                <div class="btn-list">
                  <span class="btn reset" @click="colorReset">恢复默认</span>
                </div>
              </div>
            </div>
          </div>
          <transition enter-active-class="animated fadeInUpBig">
            <div class="color-select-tab" v-if="showColor">
              <div class="color-list" v-if="activeTab == 'hair'">
                <div
                  class="color-list_slide"
                  v-for="(value, key) in dataList['clothes'].hair.colorInfo.slidePick"
                  :key="key"
                >
                  <div class="title">{{ value.text }}</div>
                  <div class="color-pick" :class="[`color-${key}`]">
                    <div
                      class="slider"
                      :style="{ left: value.left + '%' }"
                      @touchstart="touchstart($event, key)"
                      @touchmove="touchmove($event, key)"
                      @touchend="touchend($event, key)"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="color-list" v-if="activeTab == 'eyes'">
                <div class="color-wrapper">
                  <div
                    class="color-item default"
                    :class="{ active: dataList.clothes['eyes'].colorInfo.activeColor === '' }"
                    @click="colorReset"
                  >
                    默认
                  </div>
                  <div
                    v-for="(item, index) in dataList.clothes['eyes'].colorInfo.list"
                    :key="index"
                    class="color-item"
                    :class="{ active: dataList.clothes['eyes'].colorInfo.activeColor === index }"
                    @click="colorPick(index)"
                    :style="{ background: `linear-gradient(137deg, ${transformBg(item)})` }"
                  ></div>
                </div>
              </div>

              <div class="bot-btn">
                <span class="info-text">{{ typeMaps[activeTab].text }}调色</span>
                <div class="btn-list">
                  <span class="btn reset" @click="colorReset" v-if="activeTab == 'hair'">恢复默认</span>
                  <span class="btn cancel" @click="colorCancel">取消</span>
                  <span class="btn color-confirm" @click="colorConfirm">确定</span>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
      <transition enter-active-class="animated fadeInUpBig">
        <div class="action-tab" v-if="currentStep == 'picture'" :class="[`${currentStep} ${tabMode}`]">
          <div v-show="!isAction">
            <div class="main-button">
              <div class="left">
                <span class="btn random-btn" @click="$refs.stepConfirmModal.showModal({ type: 1 })">
                  <span>去摄像馆</span>
                </span>
              </div>
              <div class="middle">
                <span class="btn reset-action" :class="{ disabled: !isActionMove }" @click="resetPicture"> 复位 </span>
              </div>
              <div class="right">
                <span class="btn action-btn" @click="goAction">
                  <i class="icon-icon_pinch_16 icon"></i>
                  <span>捏动作</span>
                </span>
              </div>
              <div class="top-line">
                <img src="@/assets/img/img_spiny_54_8@2x.png" alt="" />
              </div>
            </div>
            <div class="action-nav" id="slideTab">
              <div class="action-nav-list">
                <div
                  class="action-nav-item"
                  :class="{ active: activePictureTab == key }"
                  v-for="(value, key) in pictrueMaps"
                  :key="key"
                >
                  <span :class="[value.icon]" @click="navClickPicture(key)"></span>
                </div>
              </div>
              <div class="jianbian"></div>
            </div>
            <div class="tab-list">
              <div
                class="tab-item"
                v-show="activePictureTab == type"
                v-for="(value, type) in dataList[currentStep]"
                :key="type"
                :class="[`${type}`]"
              >
                <div class="action-list">
                  <div
                    class="action-item animated fadeIn"
                    v-for="(item, index) in dataList[currentStep][type].list"
                    :key="item.id"
                    @click="pictureChoose(item, index)"
                  >
                    <div
                      class="cover"
                      :class="{ active: dataList[currentStep][type].active === index }"
                      v-if="item.thumb"
                    >
                      <img :src="item.thumb" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <transition enter-active-class="animated fadeInUpBig">
            <div class="color-select-tab" :class="{ action: isAction }" v-show="isAction" style="height: 0.98rem">
              <div class="bot-btn">
                <span class="info-text">捏动作</span>
                <div class="btn-list">
                  <span class="btn cancel" @click="actionCancel">取消</span>
                  <span class="btn color-confirm" @click="actionConfirm">确定</span>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
      <transition enter-active-class="animated fadeInUpBig">
        <div id="action-tab" class="action-tab" v-if="currentStep == 'camera'" :class="[`${currentStep} ${tabMode}`]">
          <div>
            <div class="main-button">
              <div class="left">
                <span class="btn random-btn" @click="$refs.stepConfirmModal.showModal({ type: 2 })">
                  <span>去照相馆</span>
                </span>
              </div>
              <div class="middle"></div>
              <div class="right">
                <!-- <span class="btn action-btn" @click="editText">
                  <i class="icon-icon_edit_text_16"></i>
                </span> -->
                <!-- <span class="btn reset-action" :class="{ disabled: !isActionMove }" @click="resetPicture"> 复位 </span> -->
              </div>
              <div class="top-line">
                <img src="@/assets/img/img_spiny_54_8@2x.png" alt="" />
              </div>
            </div>
            <div class="action-nav">
              <div class="action-nav-list">
                <div
                  class="action-nav-item"
                  :class="{ active: activeCameraTab == key }"
                  v-for="(value, key) in cameraMaps"
                  :key="key"
                >
                  <span :class="[value.icon]" @click="navClickCamera(key)"></span>
                </div>
              </div>
              <div class="jianbian"></div>
            </div>
            <div class="tab-list">
              <div
                class="tab-item"
                v-show="activeCameraTab == type"
                v-for="(value, type) in dataList[currentStep]"
                :key="type"
                :class="[`${type}`]"
              >
                <div class="action-list">
                  <div
                    class="action-item animated fadeIn"
                    v-for="(item, index) in dataList[currentStep][type].list"
                    :key="index"
                    @click="cameraChoose(item, index)"
                  >
                    <div
                      class="cover"
                      :class="{ active: dataList[currentStep][type].active === index }"
                      v-if="item.thumb"
                    >
                      <img :src="item.thumb" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <mobile-modal v-model="showConfirm" title="恢复默认" desc="要恢复到默认装扮吗？" @confirm="resetConfirm">
    </mobile-modal>
    <mobile-modal
      ref="stepConfirmModal"
      :title="`将会丢失在${stepMap[currentStep]}的操作，确定前往？`"
      @confirm="stepConfirm"
    >
    </mobile-modal>
    <mobile-modal
      ref="guideModal"
      :footer="false"
      :showClose="true"
      :css="{ width: '6.54rem' }"
      @toggle="guideIndex = 0"
    >
      <div class="guide" v-show="currentStep == 'picture' && !isAction">
        <div class="guide-item" v-show="guideIndex == 0">
          <div class="guide-title">选中人偶，可以进行拖动移位和双指缩放~</div>
          <div class="guide-content">
            <img src="./image/pic_guide_photo_1@2x.png" alt="" />
            <div class="process-text">1/2</div>
          </div>
          <div class="guide-btn">
            <div class="guide-next-btn" @click="guideIndex = 1">下一条</div>
          </div>
        </div>
        <div class="guide-item" v-show="guideIndex == 1">
          <div class="guide-title">进入捏动作模式，人偶动作还可以自由改变哦~</div>
          <div class="guide-content">
            <img src="./image/pic_guide_photo_2@2x.png" alt="" />
            <div class="process-text">2/2</div>
          </div>
          <div class="guide-btn">
            <div class="guide-prev-btn" @click="guideIndex = 0">上一条</div>
            <div
              class="guide-confirm-btn"
              @click="
                $refs.guideModal.hide()
                guideIndex = 0
              "
            >
              知道了
            </div>
          </div>
        </div>
      </div>
      <div class="guide" v-show="currentStep == 'picture' && isAction">
        <div class="guide-item" v-show="guideIndex == 0">
          <div class="guide-title">拖动关节点，可以自由改变人偶动作~</div>
          <div class="guide-content">
            <img src="./image/pic_guide_photo_3@2x.png" alt="" />
            <div class="process-text">1/1</div>
          </div>
          <div class="guide-btn">
            <div class="guide-confirm-btn" @click="$refs.guideModal.hide()">知道了</div>
          </div>
        </div>
      </div>
      <div class="guide" v-show="currentStep == 'camera'">
        <div class="guide-item" v-show="guideIndex == 0">
          <div class="guide-title">选中人偶，可以进行拖动移位和双指缩放~</div>
          <div class="guide-content">
            <img src="./image/pic_guide_photo_1@2x.png" alt="" />
            <div class="process-text">1/1</div>
          </div>
          <div class="guide-btn">
            <!-- <div class="guide-next-btn" @click="guideIndex = 1">下一条</div> -->
            <div class="guide-confirm-btn" @click="$refs.guideModal.hide()">知道了</div>
          </div>
        </div>
        <!-- <div class="guide-item" v-show="guideIndex == 1">
          <div class="guide-title">点击模板文字修改按钮，可修改背景模板中的文字~</div>
          <div class="guide-content">
            <img src="./image/pic_guide_camera_2@2x.png" alt="" />
            <div class="process-text">2/2</div>
          </div>
          <div class="guide-btn">
            <div class="guide-prev-btn" @click="guideIndex = 0">上一条</div>
            <div class="guide-confirm-btn" @click="$refs.guideModal.hide()">知道了</div>
          </div>
        </div> -->
      </div>
    </mobile-modal>
    <mobile-modal v-model="showConfirm2" title="确定恢复人偶默认大小和位置？" @confirm="resetConfirm2"> </mobile-modal>
    <mobile-modal v-model="showStepModal" :footer="false" :showClose="true" :css="{ width: '6.34rem' }">
      <div class="step-modal">
        <span class="title">请选择</span>
        <div class="content">
          <div @click="goPicture">
            <span>
              <svg
                t="1610964200841"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="8379"
                width="64"
                height="64"
              >
                <path
                  d="M911.36 896H432.64c-87.04-133.12-51.2-312.32 79.36-399.36 115.2-76.8 266.24-61.44 363.52 35.84 97.28 97.28 112.64 248.32 35.84 363.52z"
                  fill="#FF7401"
                  p-id="8380"
                ></path>
                <path
                  d="M867.84 921.6H161.28h-2.56C94.72 921.6 40.96 870.4 38.4 803.84V307.2c2.56-64 58.88-115.2 122.88-112.64h76.8L253.44 148.48C266.24 120.32 291.84 102.4 320 102.4h384c28.16 2.56 51.2 17.92 64 40.96v2.56l15.36 46.08h79.36c30.72 0 61.44 12.8 84.48 33.28 23.04 23.04 35.84 51.2 35.84 84.48v496.64c0 64-53.76 115.2-115.2 115.2z m-5.12-51.2c38.4 0 69.12-28.16 71.68-64V312.32c0-17.92-7.68-35.84-20.48-46.08-12.8-12.8-28.16-17.92-48.64-20.48h-117.76l-28.16-79.36c-2.56-7.68-10.24-12.8-17.92-12.8H320c-7.68 0-15.36 5.12-17.92 12.8L273.92 245.76H161.28C122.88 243.2 92.16 273.92 89.6 309.76v494.08C89.6 839.68 122.88 870.4 158.72 870.4h704z"
                  fill="#333333"
                  p-id="8381"
                ></path>
                <path
                  d="M512 768C407.04 768 320 680.96 320 576S407.04 384 512 384 704 471.04 704 576 616.96 768 512 768z m0-332.8C435.2 435.2 371.2 499.2 371.2 576S435.2 716.8 512 716.8 652.8 652.8 652.8 576 588.8 435.2 512 435.2z"
                  fill="#333333"
                  p-id="8382"
                ></path>
                <path d="M768 384m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#333333" p-id="8383"></path>
              </svg>
            </span>
            <i style="color: #666666; font-size: 0.24rem">照相馆</i>
          </div>
          <div @click="goCamera">
            <span>
              <svg
                t="1610964262350"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="8668"
                width="64"
                height="64"
              >
                <path
                  d="M542.72 858.7008c-76.8 0-145.92-2.56-179.2-5.12-56.32-153.6 20.48-325.12 174.08-384 104.96-38.4 220.16-15.36 302.08 58.88 53.76 48.64 87.04 115.2 97.28 186.88-20.48-15.36-46.08-25.6-71.68-30.72-5.12 0-10.24 2.56-12.8 5.12-7.68 7.68-7.68 23.04-7.68 40.96 0 38.4 2.56 92.16-69.12 110.08-76.8 12.8-153.6 20.48-232.96 17.92z"
                  fill="#FF7401"
                  p-id="8669"
                ></path>
                <path
                  d="M729.6 897.1008h-588.8c-71.68 0-128-56.32-128-128v-512c0-71.68 56.32-128 128-128h588.8c71.68 0 128 56.32 128 128v512c0 69.12-56.32 128-128 128z m-588.8-716.8c-43.52 0-76.8 33.28-76.8 76.8v512c0 43.52 33.28 76.8 76.8 76.8h588.8c43.52 0 76.8-33.28 76.8-76.8v-512c0-43.52-33.28-76.8-76.8-76.8h-588.8z"
                  fill="#333333"
                  p-id="8670"
                ></path>
                <path d="M204.8 321.1008m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#333333" p-id="8671"></path>
                <path
                  d="M960 753.7408c-10.24 0-17.92-2.56-25.6-5.12l-76.8-35.84c-23.04-10.24-38.4-35.84-38.4-58.88v-281.6c0-25.6 15.36-48.64 35.84-58.88l76.8-35.84c7.68-5.12 17.92-5.12 28.16-5.12 17.92 0 33.28 7.68 46.08 20.48 12.8 10.24 17.92 25.6 17.92 43.52v353.28c0 7.68-2.56 17.92-5.12 28.16-7.68 15.36-20.48 28.16-35.84 33.28-7.68 2.56-15.36 2.56-23.04 2.56z m-5.12-432.64l-76.8 35.84c-5.12 2.56-7.68 7.68-7.68 12.8v281.6c0 5.12 2.56 10.24 7.68 12.8l76.8 35.84c2.56 0 5.12 2.56 10.24 0 2.56 0 5.12-2.56 7.68-7.68V331.3408c0-5.12 0-7.68-2.56-10.24-2.56-2.56-5.12-5.12-10.24-5.12-2.56 5.12-5.12 5.12-5.12 5.12z"
                  fill="#333333"
                  p-id="8672"
                ></path>
              </svg>
            </span>
            <i style="color: #666666; font-size: 0.24rem">摄像馆</i>
          </div>
        </div>
      </div>
    </mobile-modal>
    <mobile-modal
      v-model="showExportImage"
      :footer="false"
      :showClose="true"
      :css="{ width: '4.8rem', borderRadius: '0.24rem', overflow: 'hidden' }"
    >
      <div class="result-img">
        <div class="top-info">
          <!-- <div class="bg" v-if="dataList.picture.bg.active !== ''">
            <img :src="dataList.picture.bg.list[dataList.picture.bg.active].thumb" alt="" />
          </div>
          <div class="person" v-if="exportImg" :style="{'left': exportPosition.left2 + '%', 'top': exportPosition.top2 + '%'}">
            <img :src="exportImg" alt="" />
          </div> -->
          <img :src="exportImg" alt="" />
        </div>

        <div class="bot-info">
          <span>长按保存你的二次元角色</span>
          <div class="code">
            <img :src="qrCodeUrl" alt="" />
          </div>
        </div>
        <img ref="result_img_2" v-if="resultImg" class="result_img_2" :src="resultImg" alt="" />
      </div>
    </mobile-modal>
    <mobile-modal ref="textEditorModal" :footer="false" :showClose="false" :css="{ width: '6.54rem' }">
      <div class="text-edit-form">
        <div class="title">模板文案修改</div>
        <div class="close-icon" @click="$refs.textEditorModal.hide()">
          <span class="icon-pop_icon_close_14"></span>
        </div>
        <div class="select-item" v-for="(value, key) in textEditData" :key="key">
          <div class="select-input" @click="openSelect(value)">
            <span class="text hide-text-1">{{ value.list[value.active].text }}</span>
            <span class="icon-icon_unfold_12"></span>
          </div>
          <div class="select-open" v-if="value.expand">
            <div class="select-list">
              <div
                class="select-option"
                v-for="(item, index) in value.list"
                :key="index"
                @click="selectText(value, index)"
              >
                {{ item.text }}
              </div>
            </div>

            <div class="jianbian"></div>
          </div>
        </div>
      </div>
    </mobile-modal>
  </div>
</template>

<script>
import qrcode from 'qrcode'
import mobileModal from '@/components/Zpace/modal/mobileModal.vue'
import Connector from '@/assets/js/pixi-hammer'
import { hslToRgb } from '@/utils/util'
import { mapActions } from 'vuex'
import { getRandom } from '@/utils/util.js'
import * as qiniu from 'qiniu-js'
import { DropShadowFilter } from '@pixi/filter-drop-shadow'
import SVGA from 'svgaplayerweb'
const PIXI = window.PIXI
const TWEEN = window.TWEEN
const Hammer = window.Hammer
const bgMap = {
  1: 'http://qnp.mindcomic.com/upload/image/b4b018c7e9df167254053326bce1d237.jpg',
  2: 'http://qnp.mindcomic.com/upload/image/e72ecd1e0a5533bba11c0b9ccbaaa80e.jpg',
  3: 'http://qnp.mindcomic.com/upload/image/e6dc6e668930869145a20d73f98adc7e.jpg',
  4: 'http://qnp.mindcomic.com/upload/image/ba2017ec091dd19b71d7e22803eb843f.jpg',
  5: 'http://qnp.mindcomic.com/upload/image/fd2cdb3a8cab9fee623546a80d35eb76.jpg',
  6: 'http://qnp.mindcomic.com/upload/image/d97de2fe601afdf5c641542c8ca1541d.jpg',
  7: 'http://qnp.mindcomic.com/upload/image/72ce7fb18a664a2b2c3dbe79f85ff0a4.jpg',
  8: 'http://qnp.mindcomic.com/upload/image/4b64c4e6d2588f28ca52dcef39882ee5.jpg',
  9: 'http://qnp.mindcomic.com/upload/image/fcd80d6885bc2217e3a0e7cba89817dd.jpg',
  10: 'http://qnp.mindcomic.com/upload/image/9babb54fa401cb2f282a726dc2494594.jpg',
  11: 'http://qnp.mindcomic.com/upload/image/fc8c8ce4d307bd22b9938cb69a1cf894.jpg',
  12: 'http://qnp.mindcomic.com/upload/image/d1a230e0050f5e08d7e404a2ab874b02.jpg',
  13: 'http://qnp.mindcomic.com/upload/image/ef58f13987af866b53bbf5109cafeaf8.jpg',
  14: 'http://qnp.mindcomic.com/upload/image/960c1a2edebf45e89ada5fe03ee014fb.jpg',
  15: 'http://qnp.mindcomic.com/upload/image/929172522b81d25381e26382f621f2d3.jpg',
  16: 'http://qnp.mindcomic.com/upload/image/0d9c9da2665846fed76d3bf580c7c9fc.jpg',
  17: 'http://qnp.mindcomic.com/upload/image/3f9f8d0ca5070d7d61ae66d64d870377.jpg',
  18: 'http://qnp.mindcomic.com/upload/image/69903fa971d19415be0fdb600de877b2.jpg',
  19: 'http://qnp.mindcomic.com/upload/image/1ea6d02a163ad0521c342e8205b4e10c.jpg'
}
const stepMap = {
  picture: '照相馆',
  camera: '摄像馆'
}
const typeMaps = {
  my: { text: '我的', type: 'my', icon: 'icon-tab_icon_my_22_n' },
  all: { text: '搭配', type: 'all', icon: 'icon-tab_icon_collocation_22_s' },
  upperWear: { text: '上衣', type: 'upperWear', icon: 'icon-tab_icon_coat_22_n' },
  bottomWear: { text: '下装', type: 'bottomWear', icon: 'icon-tab_icon_bottoms_22_n' },
  shoe: { text: '鞋子', type: 'shoe', icon: 'icon-tab_icon_shoes_22_n' },
  hair: { text: '发型', type: 'hair', icon: 'icon-tab_icon_hairstyle_22_n' },
  eyes: { text: '眼型', type: 'eyes', icon: 'icon-tab_icon_eye_22_n' },
  skin: { text: '肤色', type: 'skin', icon: 'icon-tab_icon_complexion_22_n' },
  headwear: { text: '头饰', type: 'headwear', icon: 'icon-tab_icon_headwear_22_n' }
  // glass: { text: '眼镜', type: 'glass', icon: 'icon-tab_icon_glasses_22_n' }
}
const pictrueMaps = {
  action: { text: '动作', type: 'my', icon: 'icon-tab_icon_action_22_n' },
  face: { text: '表情', type: 'face', icon: 'icon-tab_icon_expression_22_n' },
  bg: { text: '背景', type: 'bg', icon: 'icon-tab_icon_scenes_22_n' }
}
const cameraMaps = {
  animation: { text: '动画', type: 'animation', icon: 'icon-tab_icon_animation_22_n' },
  bg: { text: '背景', type: 'upperWear', icon: 'icon-tab_icon_pic_gif_22_n' }
}
const changeTypeList = ['all', 'upperWear', 'bottomWear', 'shoe', 'hair', 'eyes', 'headwear']
const _ = require('lodash')
const typeJson = require('@/assets/json/forZpace_en.json')
const colorJson = require('@/assets/json/color.json')
const imageMap = {
  静态_表情_乐: 'le',
  静态_表情_哀: 'ai',
  静态_表情_坏笑: 'huaixiao',
  静态_表情_大笑: 'daxiao',
  静态_表情_害羞: 'haixiu',
  静态_表情_怒: 'nu',
  静态_表情_惊讶: 'jingya',
  静态_表情_无奈: 'wunai',
  静态_肢体_叉腰: 'chayao',
  静态_肢体_打招呼: 'dazhaohu',
  静态_肢体_害羞: 'haixiu',
  静态_肢体_拜年: 'bainian',
  静态_肢体_欢呼: 'huanhu',
  静态_肢体_生气: 'shengqi',
  静态_肢体_跑: 'pao',
  静态_肢体_跳: 'tiao',
  动态_拜年: 'animation_bainian',
  动态_生气: 'animation_shengqi',
  动态_哀愁: 'animation_aichou',
  动态_害羞: 'animation_haixiu',
  动态_开心: 'animation_kaixin',
  动态_抱拳: 'animation_baoquan',
  动态_欢呼: 'animation_huanhu'
}
// const vconsole = require('vconsole')
// new vconsole()
export default {
  name: 'WoW',
  data () {
    return {
      bgMap,
      imageMap,
      stepMap,
      resultImg: '',
      showResult: false,
      qrCodeUrl: '',
      startX: '',
      startY: '',
      boneX: '',
      boneY: '',
      p_x: '',
      p_y: '',
      pStart_x: '',
      pStart_y: '',
      isMove: '',
      activeBone: {},
      changeTypeList,
      activeTab: 'all',
      activePictureTab: 'action',
      typeMaps,
      pictrueMaps,
      cameraMaps,
      currentStep: 'clothes',
      dataList: {
        clothes: {
          my: {
            list: []
          },
          all: {
            active: '', // 当前选择的素材id
            list: []
          },
          upperWear: {
            active: '',
            list: []
          },
          bottomWear: {
            active: '',
            list: []
          },
          shoe: {
            active: '',
            list: []
          },
          hair: {
            active: '',
            list: [],
            colorInfo: {
              activeColor: '',
              list: [],
              slidePick: {
                brightness: {
                  text: '亮度', // 亮度
                  left: 100
                },
                hue: {
                  text: '色相',
                  left: 100 // 色相
                },
                saturation: {
                  text: '饱和度',
                  left: 100 // 饱和度
                }
              }
            }
          },
          eyes: {
            active: '',
            list: [],
            colorInfo: {
              activeColor: '',
              list: colorJson['eyes']
            }
          },
          skin: {
            active: '',
            list: [],
            colorInfo: {
              activeColor: '',
              list: [],
              slidePick: {
                brightness: {
                  text: '亮度', // 亮度
                  left: 100
                },
                hue: {
                  text: '色相',
                  left: 100 // 色相
                },
                saturation: {
                  text: '饱和度',
                  left: 100 // 饱和度
                }
              }
            }
          },
          headwear: {
            active: '',
            list: []
          }
          // glass: {
          //   active: '',
          //   list: []
          // }
        },
        picture: {
          action: {
            active: '',
            list: []
          },
          face: {
            active: '',
            list: []
          },
          bg: {
            active: '',
            list: []
          }
        },
        camera: {
          animation: {
            active: '',
            list: []
          },
          bg: {
            active: '',
            list: [
              {
                id: 1,
                name: `sence_1`,
                thumb: require(`./image/sence/1.jpg`),
                type: 'bg'
              }
            ]
          }
        }
      },
      init_data: {
        x: 400,
        y: 3.43 * window.fs,
        scale: 0.25,
        stageWidth: 0,
        stageHeight: 0,
        scaleBig: 0.7,
        scaleBigY: 9 * window.fs
      },
      contentContain: {},
      personContain: {},
      app: {},
      Model: {},
      slicesList: [],
      myChooseList: [],
      packageInfo: {},
      packageInfoList: [],
      historyList: [],
      defaultData: {
        spineData: {},
        dataList: {}
      },
      historyIndex: -1,
      activeChoose: {},
      showConfirm: false,
      showConfirm2: false,
      showStepModal: false,

      showColor: false,
      colorStartX: 0,
      colorWidth: 0,
      personRect: null,
      scale: 0.25,
      scaleing: false,
      isActionMove: false,
      tabMode: 'full',
      isAction: false,
      bgContain: null,
      bgSprite: null,
      showExportImage: false,
      exportImg: null,
      boneContain: null,
      beforeActionSpineData: null,
      defaultColor: null,
      share_top_downlink: window.location.href,
      guideIndex: 0,
      activeCameraTab: 'animation',
      textEditData: {
        botTextImg: {
          active: 0,
          expand: false,
          list: [
            {
              text: '底部文案',
              img: require('./image/color_1.png')
            },
            {
              text: '底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案',
              img: require('./image/color_1.png')
            },
            {
              text:
                '底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案底部文案',
              img: require('./image/color_1.png')
            }
          ]
        },
        topTextImg: {
          active: 0,
          expand: false,
          list: [
            {
              text: '啊啊啊啊啊啊顶部文案',
              img: require('./image/color_1.png')
            }
          ]
        }
      },
      loading: true,
      activeColor: null,
      recordColor: null, // 记录修改前颜色
      isOver: false,
      historyListFirstElement: null, // 记录历史列表第一个的前一个数据
      exportPosition: {
        left: 0,
        bottom: 0,
        bottom2: 0,
        left2: 0
      },
      fs: window.fs,
      spineAtlas: null
    }
  },
  components: { mobileModal },
  computed: {
    isIos () {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    }
  },
  created () {
    // 漫想世界二维码
    qrcode.toDataURL(this.share_top_downlink).then((imgData) => {
      if (imgData) {
        this.qrCodeUrl = imgData
      }
    })
  },
  mounted () {
    this.init_data.stageWidth = document.querySelector('.editor').clientWidth
    this.init_data.stageHeight = document.querySelector('.editor').clientHeight
    this.init_data.x = this.init_data.stageWidth / 2
    var player = new SVGA.Player('#demoCanvas')
    var parser = new SVGA.Parser('#demoCanvas') // Must Provide same selector eg:#demoCanvas IF support IE6+
    parser.load(require('./image/loading.svga'), function (videoItem) {
      player.setVideoItem(videoItem)
      player.startAnimation()
    })
    this.init()
  },
  methods: {
    ...mapActions(['getQiniuToken']),
    /** spine交互  开始 */
    // 资源初始化
    init () {
      const app = new PIXI.Application({
        width: this.init_data.stageWidth,
        height: this.init_data.stageHeight,
        autoResize: true,
        antialias: true,
        transparent: true,
        resolution: window.devicePixelRatio || 1,
        resizeTo: document.querySelector('.editor'),
        preserveDrawingBuffer: true
      })
      // 最大的容器
      this.contentContain = new PIXI.Container()
      // 人物容器
      this.personContain = new PIXI.Container()
      // 背景容器
      this.bgContain = new PIXI.Container()

      this.bgContain.width = this.init_data.stageWidth
      this.bgContain.height = this.init_data.stageHeight

      const bgSprite = new PIXI.Graphics()
      bgSprite.beginFill(0x393e4e, 1)
      bgSprite.drawRect(0, 0, this.init_data.stageWidth, this.init_data.stageHeight)
      bgSprite.endFill()
      this.bgContain.addChild(bgSprite)

      this.contentContain.interactive = true
      this.contentContain.width = this.init_data.stageWidth
      this.contentContain.height = this.init_data.stageHeight
      this.contentContain.pivot.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.contentContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.contentContain.addChild(this.bgContain)
      this.contentContain.addChild(this.personContain)
      this.contentContain.hitArea = new PIXI.Rectangle(0, 0, this.init_data.stageWidth, this.init_data.stageHeight)
      this.app = app

      this.app.renderer.resize(
        document.querySelector('.editor').clientWidth,
        document.querySelector('.editor').clientHeight
      )
      document.querySelector('#spine').appendChild(app.view)
      this.app.stage.interactive = true
      this.app.stage.buttonMode = true
      this.loadBgList()
      this.app.loader
        .add('model', 'spineAssets/mobile2/LUOMO.json')
        .add('circle', require('./image/img_control_point@2x.png'))
        .load(this.resLoadHandler)
      this.app.stage.addChild(this.contentContain)

      window.addEventListener('resize', this.resize, false)
    },
    // 自适应
    resize () {
      this.app.resize(document.querySelector('.editor'))
      this.init_data.stageWidth = document.querySelector('.editor').clientWidth
      this.init_data.stageHeight = document.querySelector('.editor').clientHeight
      this.personContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.personContain.y = this.init_data.y
      const scale = (7 * window.fs) / this.Model.spineData.height
      this.init_data.scale = scale
      this.personContain.scale.set(scale)
    },
    async resLoadHandler (loader, resources) {
      // 加载裸模
      this.loadModel(resources.model.spineData)
      // 设置默认皮肤
      await this.loadDefaultPackage()

      this.eventInit()
      this.initAnimation()
      // this.debug()
    },
    // 加载初始模型
    loadModel (spineData) {
      this.Model = new PIXI.spine.Spine(spineData)
      window.Model = this.Model
      window.app = this.app
      this.Model.x = 0
      this.Model.y = 0
      // 模型原点有问题， 设置为左上角原点
      this.Model.pivot.set(-this.Model.spineData.width / 2, -this.Model.spineData.height)
      // 开启debug
      // this.Model.drawDebug = true
      // this.Model.drawBones = true
      this.personContain.width = this.Model.spineData.width
      this.personContain.height = this.Model.spineData.height
      this.personContain.addChild(this.Model)
      // 设置最外部容器原点为骨骼数据的宽高中点
      this.personContain.pivot.set(this.Model.spineData.width / 2, this.Model.spineData.height / 2)
      // 设置最外部容器 的位置 居中显示
      this.personContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.personContain.y = this.init_data.y
      const scale = (7 * window.fs) / this.Model.spineData.height
      this.init_data.scale = scale
      this.scale = scale
      this.personContain.scale.set(scale)
      // this.debug()
      this.personContain.interactive = false
    },
    // 初始化动画数据
    initAnimation () {
      this.Model.spineData.animations.forEach((item) => {
        if (item.name.indexOf('表情') != -1) {
          this.dataList.picture.face.list.push({
            thumb: require(`./image/face/${this.imageMap[item.name]}.png`),
            name: item.name,
            type: 'face',
            index: 0
          })
        } else if (item.name.indexOf('肢体') != -1) {
          this.dataList.picture.action.list.push({
            thumb: require(`./image/action/${this.imageMap[item.name]}.png`),
            name: item.name,
            type: 'action',
            index: 1
          })
        } else if (item.name.indexOf('动态') != -1 && item.name.indexOf('动态_讲话') == -1) {
          if (this.imageMap[item.name]) {
            this.dataList.camera.animation.list.push({
              thumb: require(`./image/animation/${this.imageMap[item.name]}.png`),
              name: item.name,
              type: 'animation',
              index: 0
            })
          }
        }
      })
    },
    // 获取素材信息
    async loadDefaultPackage () {
      await this.$api.wow.getEditorList({ types: 1 }).then((res) => {
        if (res.status == 'ok') {
          this.packageInfoList = res.data.list || []
          // 解析素材数据
          this.loadAllPackage()

          // 加载搭配列表
          this.getMatchList()

          this.app.loader.load((loader, resources) => {
            this.loading = false
          })
        }
      })
    },
    // 解析素材数据
    loadAllPackage () {
      this.packageInfoList.forEach((item) => {
        item.front_view.elements_block.forEach((element) => {
          // 添加到pixi 缓存
          for (const key in element.elements) {
            this.app.loader.add(`${element.id}_${key}`, this.constv.QINIU_IMAGE_CND_URL + element.elements[key])
          }
        })

        // 遍历给个类型的列表
        this.changeTypeList.forEach((type) => {
          // 接口数据返回找出对应部件
          const element = item.front_view.elements_block.find((item) => item.type == type)
          if (element) {
            this.dataList['clothes'][type].list.push({
              id: element.id,
              type: type,
              thumb: element.cover_img,
              elements: element.elements
            })
          }
        })
      })
      // 记录裸模初始贴图
      for (const part in typeJson['replacement']) {
        typeJson['replacement'][part].forEach((slot) => {
          const currentSlot = this.Model.skeleton.findSlot(slot)
          if (currentSlot && currentSlot.attachment) {
            const texture = currentSlot.currentMesh.texture
            if (!currentSlot.defaultTexture) {
              currentSlot.defaultTexture = texture
            }
          }
        })
      }
    },
    // // 加载裸模切片
    // loadLuomo () {
    //   return new Promise((resolve, reject) => {
    //     this.$third
    //       .get(`${this.constv.QINIU_IMAGE_CND_URL}` + 'resources/cloud/person/kyfj1614751389twbk.json')
    //       .then((res) => {
    //         for (const key in res.data) {
    //           this.app.loader.add(key, this.constv.QINIU_IMAGE_CND_URL + res.data[key])
    //         }
    //         this.slicesList = res.data

    //         this.app.loader.load((loader, resources) => {
    //           for (const part in typeJson['replacement']) {
    //             typeJson['replacement'][part].forEach((slot) => {
    //               const currentSlot = this.Model.skeleton.findSlot(slot)
    //               let texture = resources[slot] && resources[slot].texture
    //               if (currentSlot && currentSlot.attachment) {
    //                 texture = texture || currentSlot.currentMesh.texture
    //                 if (!currentSlot.defaultTexture) {
    //                   currentSlot.defaultTexture = texture
    //                 }
    //                 this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
    //               } else {
    //                 console.log('替换裸模失败' + slot)
    //               }
    //             })
    //           }
    //           resolve()
    //         })
    //       })
    //   })
    // },
    loadBgList () {
      for (let i = 1; i < 20; i++) {
        this.dataList.picture.bg.list.push({
          id: i,
          name: `sence_${i}`,
          thumb: this.bgMap[i],
          type: 'bg'
        })
        this.app.loader.add(`bg_${i}`, this.bgMap[i])
      }
    },
    transformBg (item) {
      let colorText = ''
      item = _.orderBy(item, ['stop'], ['asc'])
      item.forEach((part) => {
        colorText += `${part.rgba} ${part.stop}%,`
      })

      colorText = colorText.substring(0, colorText.length - 1)

      return colorText
    },
    // 加载可拖拽骨骼
    loadBone () {
      const bones = []
      this.boneContain = new PIXI.Container()
      this.personContain.addChild(this.boneContain)

      // 遍历骨骼
      for (let i = 0; i < this.Model.skeleton.bones.length; i++) {
        if (
          !['Ctrl3000', 'Ctrl2'].includes(this.Model.skeleton.bones[i].data.name) &&
          this.Model.skeleton.bones[i].data.name.indexOf('Ctrl') != -1
        ) {
          const item = this.Model.skeleton.bones[i]

          bones.push({ name: item.data.name, x: item.x, y: item.y })
          const sprite = new PIXI.Sprite(this.app.loader.resources['circle'].texture)

          const circleX = this.Model.spineData.width / 2 + item.worldX
          const circleY = this.Model.spineData.height + item.worldY
          sprite.scale.set(4)

          // 设置精灵图中心点为坐标起点
          sprite.anchor.set(0.5)
          sprite.x = circleX
          sprite.y = circleY
          // 设置成可点击的
          sprite.interactive = true
          sprite.buttonMode = true
          // sprite.filters = [new OutlineFilter(2, 0x99ff99)]
          this.boneContain.addChild(sprite)
          sprite
            .on('pointerdown', (e) => {
              this.pointerdown(e, item)
            })
            .on('pointermove', (e) => {
              this.pointermove(e)
            })
            .on('pointerupoutside', (e) => {
              this.pointerupoutside(e)
            })
            .on('pointerup', (e) => {
              this.pointerupoutside(e)
            })
        }
      }
      // 记录移动前的骨骼点， 方便取消后还原
      this.beforeActionSpineData = bones
    },
    // 根据插槽 替换 纹理
    hackTextureBySlotName (list) {
      for (const name in list) {
        const currentSlot = this.Model.skeleton.findSlot(name)
        const texture = this.app.loader.resources[name].texture

        if (currentSlot && currentSlot.attachment) {
          if (!currentSlot.defaultTexture) {
            currentSlot.defaultTexture = texture || currentSlot.currentMesh.texture
          }
          this.Model.hackTextureBySlotName(name, texture, { width: texture.width, height: texture.height })
        } else {
          console.log(this.Model.skeleton.findSlot(name), name, 'name')
        }
      }
    },
    createDiv (currentTarget) {
      if (this.personRect) {
        this.personContain.removeChild(this.personRect)
        this.personRect = null
        this.tabMode = 'full'
      } else {
        this.personRect = new PIXI.Graphics()
        var shadow = new DropShadowFilter(1, 0)
        shadow.resolution = window.devicePixelRatio || 1
        const { _width, _height } = this.personContain
        const width = _width
        const height = _height

        this.personRect.lineStyle(2 / this.init_data.scale, 0xffffff, 1)
        this.personRect.drawRect(0, 0, width, height)

        this.personRect.endFill()
        this.personRect.beginFill(0xffffff)
        this.personRect.drawCircle(0, 0, 4 / this.init_data.scale)
        this.personRect.drawCircle(width / 2, 0, 4 / this.init_data.scale)
        this.personRect.drawCircle(width, 0, 4 / this.init_data.scale)
        this.personRect.drawCircle(width, height / 2, 4 / this.init_data.scale)
        this.personRect.drawCircle(width, height, 4 / this.init_data.scale)
        this.personRect.drawCircle(width / 2, height, 4 / this.init_data.scale)
        this.personRect.drawCircle(0, height, 4 / this.init_data.scale)
        this.personRect.drawCircle(0, height / 2, 4 / this.init_data.scale)
        this.personRect.endFill()
        shadow.blur = 1
        shadow.alpha = 0.4
        shadow.distance = 0
        shadow.rotation = 0
        this.personRect.filters = [shadow]
        this.personRect.hitArea = new PIXI.Rectangle(0, 0, width, height)
        // this.personRect.pivot.set(_width / 2, _height / 2)

        this.personContain.addChild(this.personRect)
        this.tabMode = 'halt'
      }
    },
    // 模型事件初始化
    eventInit () {
      // 模型拖拽
      this.personContain

        .on('pointerdown', (e) => {
          const currentTarget = e.currentTarget
          const { x, y } = e.data.global
          currentTarget.dragging = true
          this.p_x = x
          this.p_y = y
          this.pStart_x = currentTarget.x
          this.pStart_y = currentTarget.y

          this.createDiv(currentTarget)
          e.stopPropagation()
        })
        .on('pointertap', (e) => {
          console.log(e)
          // this.createDiv()
        })
        .on('pointermove', (e) => {
          const { x, y } = e.data.global
          const currentTarget = e.currentTarget
          if (currentTarget.dragging && !this.scaleing) {
            this.isActionMove = true
            let moveX = x - this.p_x + this.pStart_x
            let moveY = y - this.p_y + this.pStart_y
            if (moveX < 0) {
              moveX = 0
            } else if (moveX > this.init_data.stageWidth) {
              moveX = this.init_data.stageWidth
            }
            if (moveY > 9 * window.fs) {
              moveY = 9 * window.fs
            } else if (moveY < 0) {
              moveY = 0
            }
            currentTarget.x = moveX
            currentTarget.y = moveY
          }
        })
        .on('pointerupoutside', (e) => {
          this.pointerupoutside(e)
        })
        .on('pointerup', (e) => {
          this.pointerupoutside(e)
        })

      this.contentContain.on('pointerdown', (e) => {
        this.tabMode = 'full'
        this.personContain.removeChild(this.personRect)
        this.personRect = null
      })
      var hammertime = new Hammer.Manager(this.app.view, {
        recognizers: [
          [Hammer.Pinch],
          [Hammer.Pan],
          [Hammer.Tap, { event: 'doubletap', taps: 2, threshold: 7, posThreshold: 25 }],
          [Hammer.Tap, { event: 'singletap', threshold: 7 }],
          [Hammer.Press, { time: 333, threshold: 3 }],
          [Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }]
        ]
      })
      const c = new Connector(this.app.view, this.app.renderer.plugins.interaction, hammertime)
      c.registerHandlerTypes([
        'tap',
        'panstart',
        'pan',
        'panend',
        'pinchstart',
        'pinch',
        'pinchend',
        'pinchin',
        'pinchout'
      ])

      this.personContain.on('hammer-pinchout', (evt) => {
        this.scaleing = true
        let zoom = 0.01 + this.scale
        zoom = Math.max(this.init_data.scale, zoom) // 最小为原来的1/10
        zoom = Math.min(3, zoom) // 最大是原来的3倍
        this.scale = zoom
        this.personContain.scale.set(this.scale)
        this.isActionMove = true
      })
      this.personContain.on('hammer-pinchin', (evt) => {
        this.scaleing = true
        let zoom = -0.01 + this.scale
        zoom = Math.max(this.init_data.scale, zoom) // 最小为原来的1/10
        zoom = Math.min(3, zoom) // 最大是原来的3倍
        this.scale = zoom
        this.personContain.scale.set(this.scale)
        this.isActionMove = true
      })
      this.personContain.on('hammer-pinchend', (evt) => {
        this.scaleing = false
        this.app.renderer.render(this.app.stage)
      })

      // 监听滚轮放大缩小
      // document.querySelector('#spine').addEventListener('mousewheel', (event) => {
      //   let zoom = (event.deltaY > 0 ? -0.1 : 0.1) + this.scale
      //   zoom = Math.max(1, zoom) // 最小为原来的1/10
      //   zoom = Math.min(3, zoom) // 最大是原来的3倍
      //   this.scale = zoom
      //   this.contentContain.scale.set(this.scale)
      // })
    },
    pointerdown (e, item) {
      const currentTarget = e.currentTarget
      const { x, y } = e.data.global

      currentTarget.dragging = true
      currentTarget.alpha = 0.5
      this.activeBone = item
      this.startY = y
      this.startX = x
      this.boneX = item.x
      this.boneY = item.y
    },
    pointerupoutside (e) {
      const currentTarget = e.currentTarget
      currentTarget.alpha = 1
      currentTarget.dragging = false
    },
    pointermove (e) {
      const currentTarget = e.currentTarget
      let { x, y } = e.data.global

      if (currentTarget.dragging) {
        if (x <= 50) x = 50
        if (x >= this.init_data.stageWidth - 50) x = this.init_data.stageWidth - 50
        if (y >= this.init_data.stageHeight - 2 * window.fs) y = this.init_data.stageHeight - 2 * window.fs
        if (y <= 50) y = 50
        const moveX = (x - this.startX) / this.init_data.scale + (this.Model.spineData.width / 2 + this.boneX)
        const moveY = (y - this.startY) / this.init_data.scale + (this.Model.spineData.height - this.boneY)
        currentTarget.x = moveX
        currentTarget.y = moveY
        this.activeBone.x = (x - this.startX) / this.init_data.scale + this.boneX
        this.activeBone.y = -(y - this.startY) / this.init_data.scale + this.boneY
        this.isActionMove = true
      }
    },
    // 重新加载模型
    reloadModel (spineData) {
      this.personContain.removeChild(this.Model)
      this.Model = null
      this.loadModel(spineData)
      this.hackTextureBySlotName(this.slicesList)
      if (this.activeTab == 'hair' || this.activeTab == 'eyes') {
        this.personContain.scale.set(this.init_data.scaleBig)
        this.personContain.y = this.init_data.scaleBigY
      }
    },
    getMatchList () {
      this.$api.wow.getMatchList().then((res) => {
        if (res.status == 'ok') {
          this.dataList.clothes.all.list = res.data.list.map((item) => {
            return { thumb: item.image, id: item.id, type: 'all', elements_block: item.elements_block }
          })
          this.defaultData.spineData = _.cloneDeep(this.Model)
          this.defaultData.dataList = _.cloneDeep(this.dataList)
        }
      })
    },

    /** spine交互  结束 */

    /** 编辑器交互  开始 */
    /** 第一步 换装交互 开始 */
    modelAnimate (sprite, option) {
      requestAnimationFrame(this.modelAnimate)
      TWEEN.update()
    },
    setAnimate (sprite, from, to, time) {
      new TWEEN.Tween(from)
        .to(to, time)
        .easing(TWEEN.Easing.Cubic.Out)
        .onUpdate((object) => {
          sprite.scale.set(object.scale)
          sprite.y = object.y
        })
        .start()

      this.modelAnimate()
    },
    navClick (type) {
      if (this.activeTab == type) return
      const arr = ['hair', 'eyes']
      // 缩放逻辑
      if (arr.includes(type)) {
        if (!arr.includes(this.activeTab)) {
          // 放大
          this.setAnimate(
            this.personContain,
            { scale: this.init_data.scale, y: this.init_data.y },
            { scale: this.init_data.scaleBig, y: this.init_data.scaleBigY },
            200
          )
        }
      } else {
        if (arr.includes(this.activeTab)) {
          // 缩小
          this.setAnimate(
            this.personContain,
            { scale: this.init_data.scaleBig, y: this.init_data.scaleBigY },
            { scale: this.init_data.scale, y: this.init_data.y },
            200
          )
        }
      }
      this.activeTab = type
    },
    /**
     * 重置某个部位为默认
     * @item 当前部位
     */
    resetPart (item) {
      if (item.type == 'all') {
        for (const key in typeJson['replacement']) {
          typeJson['replacement'][key].forEach((slot) => {
            const activeSlot = this.Model.skeleton.findSlotByNameSuffix(slot)

            if (activeSlot && activeSlot.attachment) {
              // 刚开始裸模的 贴图
              const texture = activeSlot.defaultTexture
              const slotName = activeSlot.data.name

              if (texture && slotName == slot) {
                this.Model.hackTextureBySlotName(slotName, texture, { width: texture.width, height: texture.height })
                console.log('重置替换成功, 当前激活插槽：', slot)
              } else {
                const attachment = this.Model.skeleton.getAttachmentByName(slotName, slot)

                if (attachment && attachment.region && attachment.region.tempTexture) {
                  // const region = this.app.loader.resources.model.spineAtlas.findRegion(slot)
                  attachment.region.texture = attachment.region.tempTexture.clone()

                  if (activeSlot.meshes[slot]) activeSlot.meshes[slot].texture = attachment.region.tempTexture.clone()
                  console.log('重置替换成功, 其他插槽：', slot, attachment)
                }
              }
            } else {
              // this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
              console.log('重置替换失败, 找不到此插槽：', slot)
            }
          })
        }
      } else {
        // 换为裸模切片
        typeJson['replacement'][item.type].forEach((slot) => {
          const activeSlot = this.Model.skeleton.findSlotByNameSuffix(slot)

          if (activeSlot && activeSlot.attachment) {
            // 刚开始裸模的 贴图
            const texture = activeSlot.defaultTexture
            const slotName = activeSlot.data.name
            const attachment = this.Model.skeleton.getAttachmentByName(slotName, slot)
            if (texture && slotName == slot) {
              this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
            } else {
              if (attachment && attachment.region && attachment.region.tempTexture) {
                // const region = this.app.loader.resources.model.spineAtlas.findRegion(slot)
                attachment.region.texture = attachment.region.tempTexture.clone()

                if (activeSlot.meshes[slot]) activeSlot.meshes[slot].texture = attachment.region.tempTexture.clone()
                console.log('重置替换成功, 其他插槽：', slot, attachment, activeSlot)
              }
            }
          } else {
            // this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
            console.log('替换失败', slot)
          }
        })
      }
    },
    choose (item) {
      // 重置部件为默认
      this.resetPart(item)
      if (this.dataList['clothes'][this.activeTab].active === item.id) {
        // 已选择，则取消
        this.dataList['clothes'][this.activeTab].active = ''

        // 在我的列表删除

        if (item.type == 'all') {
          item.elements_block.forEach((element) => {
            this.dataList['clothes'][element.type].active = ''
            const index = this.dataList['clothes']['my'].list.findIndex((value) => value.type == element.type)
            if (index != -1) {
              this.dataList['clothes'].my.list.splice(index, 1)
            }
          })
        } else {
          const index = this.dataList['clothes']['my'].list.findIndex((value) => value.type == item.type)
          if (index != -1) {
            this.dataList['clothes'].my.list.splice(index, 1)
          }
        }
      } else {
        this.dataList['clothes'][this.activeTab].active = item.id
        // 换装逻辑
        if (item.type == 'all') {
          // 添加到我的逻辑
          this.dataList['clothes']['my'].list = []
          item.elements_block.forEach((element) => {
            this.dataList['clothes'][element.type].active = element.id
            for (const slot in element.elements) {
              const texture = this.app.loader.resources[element.id + '_' + slot].texture
              // 根据后缀名字匹配对应插槽
              const currentSlot = this.Model.skeleton.findSlotByNameSuffix(slot)
              const attachments = this.Model.skeleton.getAllAttachment()
              const attachment = attachments[slot]
              if (attachment) {
                if (!attachment.region.tempTexture) attachment.region.tempTexture = attachment.region.texture.clone()
                // 替换插槽下其它附件贴图
                attachment.region.texture = texture
                // 同时要修改插槽中meshes对象中的贴图，动画会用到这里的mesh
                console.log(currentSlot, '=========')
                if (currentSlot.meshes[slot]) currentSlot.meshes[slot].texture = texture
              }

              // if (currentSlot && currentSlot.attachment) {
              //   currentSlot.currentTexture = texture
              //   const slotName = currentSlot.data.name
              //   const attachment = this.Model.skeleton.getAttachmentByName(slotName, slot)
              //   // 替换当前激活的附件贴图
              //   if (currentSlot.attachment.name == slot) {
              //     this.Model.hackTextureBySlotName(slotName, texture, { width: texture.width, height: texture.height })
              //     console.log('更换当前附件成功：' + currentSlot.attachment.name, slot, attachment)
              //   } else { // 替换其它附件的贴图
              //     if (attachment) {
              //       // 替换前保存原来的贴图， 用于后面换下贴图
              //       if (!attachment.region.tempTexture) attachment.region.tempTexture = attachment.region.texture.clone()
              //       // 替换插槽下其它附件贴图
              //       attachment.region.texture = texture
              //       // 同时要修改插槽中meshes对象中的贴图，动画会用到这里的mesh
              //       if (currentSlot.meshes[slot]) currentSlot.meshes[slot].texture = texture
              //       console.info('更换其他附件成功：' + attachment.name, attachment)
              //     }
              //   }
              // } else {
              //   console.log('换装失败， 找不到对应插槽：' + slot)
              // }
            }

            this.dataList['clothes'].my.list.push({
              ...element,
              thumb: element.cover_img,
              index: this.changeTypeList.indexOf(element.type)
            })
          })
        } else {
          this.changeByType(item.id, item.type)
          // 添加到我的逻辑
          const index = this.dataList['clothes']['my'].list.findIndex((value) => value.type == item.type)
          if (index != -1) {
            this.dataList['clothes'].my.list.splice(index, 1, {
              ...item,
              index: this.changeTypeList.indexOf(item.type)
            })
          } else {
            this.dataList['clothes'].my.list.push({ ...item, index: this.changeTypeList.indexOf(item.type) })
          }
        }
      }

      // 我的列表排序
      if (this.dataList['clothes'].my.list.length > 1) {
        this.dataList['clothes'].my.list = this.dataList['clothes'].my.list.sort((a, b) => a.index - b.index)
      }

      // 历史记录逻辑
      this.addToHistory(item)
    },
    changeByType (id, type) {
      // 找出对应部位的切片
      const list = this.dataList.clothes[type].list.find((i) => i.id == id).elements

      for (const slot in list) {
        const texture = this.app.loader.resources[id + '_' + slot].texture
        const currentSlot = this.Model.skeleton.findSlotByNameSuffix(slot)
        const slotName = currentSlot.data.name
        const attachments = this.Model.skeleton.getAllAttachment()
        const attachment = attachments[slot]

        if (currentSlot && currentSlot.attachment) {
          // 记录当前的贴图 用于替换颜色

          currentSlot.currentTexture = texture.clone()

          if (
            type === 'eyes' &&
            typeJson['colorCtrl']['eyes'].includes(slot) &&
            this.dataList.clothes['eyes'].colorInfo.activeColor !== ''
          ) {
            const { width, height } = texture
            const pixel = this.app.renderer.plugins.extract.pixels(new PIXI.Sprite(texture))
            const item = this.dataList.clothes['eyes'].colorInfo.list[
              this.dataList.clothes['eyes'].colorInfo.activeColor
            ]
            this.hsvTransform(pixel, item).then((res) => {
              const texture = new PIXI.Texture.fromBuffer(res, width, height)
              // currentSlot.currentTexture = texture
              // this.app.stage.addChild(new PIXI.Sprite(texture))
              // console.log(slotName, '替换成功', currentSlot)
              if (currentSlot.attachment.name == slot) {
                this.Model.hackTextureBySlotName(slotName, texture, { width: texture.width, height: texture.height })
              }
            })
          } else {
            // slot 插槽里面的附件,可以存在多个， slotName 插槽名字
            // console.log(slot, slotName, '替换成功', this.Model.skeleton.getAttachmentByName(slotName, slot))
            // this.Model.hackTextureBySlotName(slotName, texture, { width: texture.width, height: texture.height }, slot)

            // 替换其它附件的贴图
            if (attachment) {
              // 替换前保存原来的贴图， 用于后面换下贴图
              if (!attachment.region.tempTexture) attachment.region.tempTexture = attachment.region.texture.clone()
              // 替换插槽下其它附件贴图
              attachment.region.texture = texture
              // 同时要修改插槽中meshes对象中的贴图，动画会用到这里的mesh
              if (currentSlot.meshes[slot]) currentSlot.meshes[slot].texture = texture
              console.info('更换其他附件成功：' + attachment.name, attachment, currentSlot)
            }
          }
        } else {
        }
      }
    },
    addToHistory (item) {
      if (this.historyIndex + 1 < this.historyList.length) {
        this.historyList.length = this.historyIndex + 1
      }

      if (this.historyList.length > 9) {
        this.historyIndex = 9
        // 是否超过十条
        this.isOver = true
        this.historyListFirstElement = this.historyList.shift()
        this.historyList.push({ ...item, spineData: _.cloneDeep(this.Model), dataList: _.cloneDeep(this.dataList) })
      } else {
        this.historyList.push({ ...item, spineData: _.cloneDeep(this.Model), dataList: _.cloneDeep(this.dataList) })
        // 历史记录逻辑
        this.historyIndex += 1
      }
    },
    // 上一历史记录
    prevClick () {
      this.historyIndex -= 1
      if (this.historyIndex == -1 && !this.isOver) {
        // 未超过十次
        // this.reloadModel(this.app.loader.resources.model.spineData)
        this.personContain.removeChild(this.Model)
        this.Model = _.cloneDeep(this.defaultData.spineData)
        this.personContain.addChild(this.Model)
        this.dataList = _.cloneDeep(this.defaultData.dataList)
        this.hackTextureBySlotName(this.slicesList)
      } else if (this.historyIndex == -1 && this.isOver) {
        // 大于等于十次 加载历史列表第一个前面的数据
        this.personContain.removeChild(this.Model)
        this.Model = _.cloneDeep(this.historyListFirstElement.spineData)
        this.personContain.addChild(this.Model)
        this.dataList = _.cloneDeep(this.historyListFirstElement.dataList)
      } else {
        this.personContain.removeChild(this.Model)
        this.Model = _.cloneDeep(this.historyList[this.historyIndex].spineData)
        this.personContain.addChild(this.Model)
        this.dataList = _.cloneDeep(this.historyList[this.historyIndex].dataList)
      }
    },
    // 下一历史记录
    nextClick () {
      this.historyIndex += 1

      this.personContain.removeChild(this.Model)
      this.Model = _.cloneDeep(this.historyList[this.historyIndex].spineData)
      this.personContain.addChild(this.Model)
      this.dataList = this.historyList[this.historyIndex].dataList
    },
    // 恢复默认弹窗
    resetClick () {
      this.showConfirm = true
    },
    // 恢复默认弹窗确认
    resetConfirm () {
      this.resetToDefault()
      this.showConfirm = false
    },
    // 动作复位
    resetConfirm2 () {
      this.showConfirm2 = false
      this.tabMode = 'full'
      this.isActionMove = false
      this.personContain.scale.set(this.init_data.scale)
      this.personContain.x = this.init_data.x
      this.personContain.y = this.init_data.y
      if (this.personRect) this.personContain.removeChild(this.personRect)
      // if (this.dataList.picture.action.active) this.dataList.picture.action.active = ''
      // if (this.dataList.camera.animation.active) this.dataList.camera.animation.active = ''
      // if (this.dataList.picture.bg.active) this.dataList.picture.bg.active = ''
      // if (this.dataList.camera.bg.active) this.dataList.camera.bg.active = ''
    },
    // 恢复默认
    resetToDefault () {
      this.historyList = []
      this.isOver = false
      this.historyIndex = -1
      this.dataList['clothes']['my'].list = []

      for (const key in this.dataList['clothes']) {
        if (key != 'my') {
          this.dataList['clothes'][key].active = ''
        }
        if (['eyes', 'hair', 'skin'].includes(key)) {
          // 颜色重置
          this.dataList.clothes[key].colorInfo.activeColor = ''
          this.dataList.clothes[key].colorInfo.slidePick = {
            brightness: {
              text: '亮度', // 亮度
              left: 100
            },
            hue: {
              text: '色相',
              left: 100 // 色相
            },
            saturation: {
              text: '饱和度',
              left: 100 // 饱和度
            }
          }
        }
      }
      for (const part in typeJson['replacement']) {
        typeJson['replacement'][part].forEach((slot) => {
          const currentSlot = this.Model.skeleton.findSlot(slot)

          if (currentSlot && currentSlot.attachment) {
            const texture = currentSlot.defaultTexture
            this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
          } else {
            console.log('替换裸模失败' + slot)
          }
        })
      }
    },
    // 删除
    deleteChoose (item, index) {
      this.dataList['clothes']['my'].list.splice(index, 1)
      this.dataList['clothes'][item.type].active = ''
      this.dataList['clothes']['all'].active = ''

      // 重置部件为默认
      this.resetPart(item)
      // 添加在历史记录
      this.addToHistory({ type: 'delete' })
    },
    // 下一步
    nextStep () {
      this.showStepModal = true
      if (['hair', 'eyes'].includes(this.activeTab) && this.showColor) {
        this.colorConfirm()
      }
    },
    goPicture () {
      this.currentStep = 'picture'
      this.showStepModal = false
      this.personContain.interactive = true
      this.personContain.buttonMode = true
      this.Model.state.clearTracks()
      // 重置摄像馆
      this.resetCamera()
      this.setAnimate(
        this.personContain,
        { scale: this.init_data.scaleBig, y: this.init_data.scaleBigY },
        { scale: this.init_data.scale, y: this.init_data.y },
        0
      )
      if (!localStorage.getItem('zpace_picture')) {
        this.$refs.guideModal.showModal()
        localStorage.setItem('zpace_picture', '1')
      }
      this.$nextTick(() => {
        //  监听面板上下滑动
        const myElement = document.querySelector('#slideTab')
        // document.body.addEventListener('touchmove', function (e) {
        //   e.preventDefault()
        // }, { passive: false })
        // document.querySelector('#slideTab').addEventListener('touchstart', function (event) {
        //   event.preventDefault()
        // })
        var hammerTab = new Hammer(myElement)
        hammerTab.get('swipe').set({ direction: Hammer.DIRECTION_ALL })
        hammerTab.on('swipeup', (ev) => {
          if (this.currentStep == 'picture') {
            this.tabMode = 'full'
          }
        })
        hammerTab.on('swipedown', (ev) => {
          if (this.currentStep == 'picture') {
            this.tabMode = 'halt'
          }
        })
      })
    },
    goCamera () {
      this.currentStep = 'camera'
      this.showStepModal = false
      this.personContain.interactive = false
      this.personContain.buttonMode = false
      this.personContain.filters = [new DropShadowFilter(10, 0)]
      this.setAnimate(
        this.personContain,
        { scale: this.init_data.scaleBig, y: this.init_data.scaleBigY },
        { scale: this.init_data.scale + 0.02, y: this.init_data.y },
        0
      )
      this.Model.state.setAnimation(0, '动态_讲话', true)
      // if (!localStorage.getItem('zpace_camera')) {
      //   this.$refs.guideModal.showModal()
      //   localStorage.setItem('zpace_camera', '1')
      // }
    },
    prevStep () {
      this.currentStep = 'clothes'
      if (['hair', 'eyes'].includes(this.activeTab)) {
        this.scaleToBig()
      } else {
        this.scaleToSmall()
      }
      this.personContain.interactive = false
      this.personContain.buttonMode = false
      this.Model.state.clearTracks()
      this.resetCamera()
    },
    scaleToBig () {
      this.setAnimate(
        this.personContain,
        { scale: this.init_data.scale, y: this.init_data.y },
        { scale: this.init_data.scaleBig, y: this.init_data.scaleBigY },
        0
      )
    },
    scaleToSmall () {
      this.setAnimate(
        this.personContain,
        { scale: this.init_data.scaleBig, y: this.init_data.scaleBigY },
        { scale: this.init_data.scale, y: this.init_data.y },
        0
      )
    },
    resetCamera () {
      // 去掉阴影
      this.personContain.filters = []
      if (this.bgSprite) {
        this.bgContain.removeChild(this.bgSprite)
        this.dataList.camera['bg'].active = ''
      }
      this.dataList.camera['animation'].active = ''
    },
    randomClick () {
      const typeList = ['upperWear', 'bottomWear', 'shoe', 'hair', 'eyes', 'headwear'] //
      typeList.forEach((item) => {
        if (['headwear'].includes(item)) {
          if (Math.random() > 0.5) {
            const index = Math.floor(this.dataList['clothes'][item].list.length * Math.random())
            const part = this.dataList['clothes'][item].list[index]
            this.dataList['clothes'][item].active = part.id
            this.resetPart(part)
            if (part.elements) {
              // 添加到我的逻辑
              const index = this.dataList['clothes']['my'].list.findIndex((value) => value.type == part.type)
              if (index != -1) {
                this.dataList['clothes'].my.list.splice(index, 1, {
                  ...part,
                  thumb: part.thumb,
                  index: this.changeTypeList.indexOf(part.type)
                })
              } else {
                this.dataList['clothes'].my.list.push({
                  ...part,
                  thumb: part.thumb,
                  index: this.changeTypeList.indexOf(part.type)
                })
              }
              for (const slot in part.elements) {
                console.log(this.app.loader.resources[part.id + '_' + slot], part, slot, 'slot')
                const texture = this.app.loader.resources[part.id + '_' + slot].texture
                if (texture && this.Model.skeleton.findSlot(slot) && this.Model.skeleton.findSlot(slot).attachment) {
                  this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
                }
              }
            }
          }
        } else {
          const index = Math.floor(this.dataList['clothes'][item].list.length * Math.random())
          const part = this.dataList['clothes'][item].list[index]
          this.dataList['clothes'][item].active = part.id
          this.resetPart(part)

          if (part.elements) {
            // 添加到我的逻辑

            const index = this.dataList['clothes']['my'].list.findIndex((value) => value.type == part.type)
            if (index != -1) {
              this.dataList['clothes'].my.list.splice(index, 1, {
                ...part,
                thumb: part.thumb,
                index: this.changeTypeList.indexOf(part.type)
              })
            } else {
              this.dataList['clothes'].my.list.push({
                ...part,
                thumb: part.thumb,
                index: this.changeTypeList.indexOf(part.type)
              })
            }
            for (const slot in part.elements) {
              console.log(this.app.loader.resources[part.id + '_' + slot], part, slot, 'slot')
              const texture = this.app.loader.resources[part.id + '_' + slot].texture
              if (texture && this.Model.skeleton.findSlot(slot) && this.Model.skeleton.findSlot(slot).attachment) {
                this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
              }
            }
          }
        }
      })
      this.addToHistory({ type: `randomChange` })
    },
    colorClick () {
      this.showColor = true
      if (this.activeTab === 'eyes' || this.activeTab === 'hair') {
        // 记录取消前的颜色信息  点击取消后恢复
        this.dataList.clothes.hair.colorInfo.slidePickRecord = _.cloneDeep(
          this.dataList.clothes.hair.colorInfo.slidePick
        )
        this.recordColor = this.dataList.clothes[this.activeTab].colorInfo.activeColor
      }
    },
    colorReset () {
      this.activeColor = ''
      if (this.activeTab == 'eyes') {
        this.dataList.clothes.eyes.colorInfo.activeColor = ''
        typeJson.colorCtrl[this.activeTab].forEach((slot) => {
          const activeSlot = this.Model.skeleton.findSlot(slot)
          if (activeSlot && activeSlot.attachment) {
            const texture = activeSlot.currentTexture
            texture && this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
          }
        })
      } else if (this.activeTab == 'hair') {
        this.dataList.clothes.hair.colorInfo.activeColor = ''
        typeJson.colorCtrl[this.activeTab].forEach((slot) => {
          const activeSlot = this.Model.skeleton.findSlot(slot)
          if (activeSlot) {
            activeSlot.color.r = 1
            activeSlot.color.g = 1
            activeSlot.color.b = 1
          }
        })
        // 记录取消前的颜色信息  点击取消后恢复
        this.dataList.clothes.hair.colorInfo.slidePickRecord = _.cloneDeep(
          this.dataList.clothes.hair.colorInfo.slidePick
        )
        this.dataList.clothes.hair.colorInfo.slidePick = {
          brightness: {
            text: '亮度', // 亮度
            left: 100
          },
          hue: {
            text: '色相',
            left: 100 // 色相
          },
          saturation: {
            text: '饱和度',
            left: 100 // 饱和度
          }
        }
      } else if (this.activeTab == 'skin') {
        this.dataList.clothes.skin.colorInfo.activeColor = ''
        typeJson.colorCtrl[this.activeTab].forEach((slot) => {
          const activeSlot = this.Model.skeleton.findSlot(slot)
          if (activeSlot) {
            this.dataList['clothes'][this.activeTab].colorInfo.activeColor = ''
            activeSlot.color.r = 1
            activeSlot.color.g = 1
            activeSlot.color.b = 1
          }
        })
        this.dataList.clothes.skin.colorInfo.slidePick = {
          brightness: {
            text: '亮度', // 亮度
            left: 100
          },
          hue: {
            text: '色相',
            left: 100 // 色相
          },
          saturation: {
            text: '饱和度',
            left: 100 // 饱和度
          }
        }
      }
    },
    colorCancel () {
      this.dataList.clothes[this.activeTab].colorInfo.activeColor = this.recordColor

      if (this.activeTab === 'hair') {
        this.dataList.clothes.hair.colorInfo.slidePick = _.cloneDeep(
          this.dataList.clothes.hair.colorInfo.slidePickRecord
        )
        if (this.dataList['clothes'][this.activeTab].colorInfo.activeColor !== '') {
          typeJson.colorCtrl[this.activeTab].forEach((slot) => {
            const activeSlot = this.Model.skeleton.findSlot(slot)
            if (activeSlot) {
              const rgb = this.dataList['clothes'][this.activeTab].colorInfo.activeColor
              activeSlot.color.r = rgb[0]
              activeSlot.color.g = rgb[1]
              activeSlot.color.b = rgb[2]
            }
          })
        } else {
          typeJson.colorCtrl[this.activeTab].forEach((slot) => {
            const activeSlot = this.Model.skeleton.findSlot(slot)
            if (activeSlot) {
              activeSlot.color.r = 1
              activeSlot.color.g = 1
              activeSlot.color.b = 1
            }
          })
        }
      } else if (this.activeTab === 'eyes') {
        if (this.dataList.clothes[this.activeTab].colorInfo.activeColor === '') {
          // 如果是空则加载原来的眼睛纹理 恢复默认
          typeJson.colorCtrl[this.activeTab].forEach((slot) => {
            const activeSlot = this.Model.skeleton.findSlot(slot)
            if (activeSlot && activeSlot.attachment) {
              const texture = activeSlot.currentTexture
              texture &&
                this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
            }
          })
        } else {
          typeJson.colorCtrl[this.activeTab].forEach((slot) => {
            const color = this.dataList.clothes['eyes'].colorInfo.list[
              this.dataList.clothes['eyes'].colorInfo.activeColor
            ]
            this.changeTextureColor(slot, color)
          })
        }
      }

      this.showColor = false
    },
    changeTextureColor (slot, color) {
      const activeSlot = this.Model.skeleton.findSlot(slot)
      if (activeSlot && activeSlot.attachment) {
        const texture = activeSlot.currentTexture
        const { width, height } = texture
        const pixel = this.app.renderer.plugins.extract.pixels(new PIXI.Sprite(texture))
        this.hsvTransform(pixel, color).then((res) => {
          const texture = new PIXI.Texture.fromBuffer(res, width, height)
          this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
        })
      }
    },
    colorConfirm () {
      this.showColor = false
      if (this.activeTab === 'hair') {
        this.dataList['clothes'][this.activeTab].colorInfo.activeColor = this.activeColor
      } else if (this.activeTab === 'eyes') {
        this.dataList['clothes'][this.activeTab].colorInfo.activeColor = this.activeColor
      }

      this.addToHistory({ type: `${this.activeTab}_colorChange` })
    },
    touchstart (e, item) {
      this.colorStartX = e.touches[0].clientX
      this.$nextTick(() => {
        this.colorWidth = document.querySelector('.color-pick').clientWidth
      })
    },
    touchmove (e, key) {
      const dis = e.changedTouches[0].clientX - document.querySelector('.color-pick').getBoundingClientRect().left
      e.preventDefault()
      if (dis > 0) {
        this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick[key].left = Math.floor(
          (Math.abs(dis) / this.colorWidth) * 100
        )
      }

      // if (this.colorStartX - e.changedTouches[0].clientX < 0) {
      //  this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick[key].left += 100 - Math.floor((dis / this.colorWidth) * 100)
      // } else {
      //  this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick[key].left = 100 - Math.floor((dis / this.colorWidth) * 100)
      // }

      if (this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick[key].left > 100) {
        this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick[key].left = 100
      } else if (this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick[key].left < 0) {
        this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick[key].left = 0
      }
      const h = this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick['hue'].left / 100
      const s = this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick['saturation'].left / 100
      const l = this.dataList[this.currentStep][this.activeTab].colorInfo.slidePick['brightness'].left / 100
      const rgb = hslToRgb(h, s, l)
      this.activeColor = rgb
      console.log(hslToRgb(h, s, l))
      typeJson.colorCtrl[this.activeTab].forEach((slot) => {
        const activeSlot = this.Model.skeleton.findSlot(slot)
        if (activeSlot) {
          if (this.activeTab === 'skin') {
            this.dataList['clothes']['skin'].colorInfo.activeColor = rgb
          }

          activeSlot.color.r = rgb[0]
          activeSlot.color.g = rgb[1]
          activeSlot.color.b = rgb[2]
        }
      })
    },
    touchend (e) {
      if (this.activeTab == 'skin') {
        this.addToHistory({ type: `${this.activeTab}_colorChange` })
      }
    },
    // 渐变映射 选择
    colorPick (index) {
      const item = this.dataList.clothes['eyes'].colorInfo.list[index]
      console.log(item, index)
      this.dataList.clothes[this.activeTab].colorInfo.activeColor = index
      this.activeColor = index
      typeJson.colorCtrl[this.activeTab].forEach((slot) => {
        const activeSlot = this.Model.skeleton.findSlot(slot)

        if (activeSlot && activeSlot.attachment) {
          // if (!activeSlot.defaultTexture) {
          //   if (activeSlot.currentMesh.texture) {
          //     activeSlot.defaultTexture = activeSlot.currentMesh.texture
          //   } else {
          //     console.log('没有当前插槽贴图')
          //   }
          // }
          const texture = activeSlot.currentTexture
          const { width, height } = texture
          const pixel = this.app.renderer.plugins.extract.pixels(new PIXI.Sprite(texture))

          this.hsvTransform(pixel, item).then((res) => {
            const texture = new PIXI.Texture.fromBuffer(res, width, height)

            // this.app.stage.addChild(new PIXI.Sprite(texture))
            this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
          })
        } else {
          console.log('替换颜色没找到对应插槽' + slot)
        }
      })
    },
    rgb2hsv (r, g, b) {
      var computedH = 0
      var computedS = 0
      var computedV = 0

      // remove spaces from input RGB values, convert to int
      r = parseInt(('' + r).replace(/\s/g, ''), 10)
      g = parseInt(('' + g).replace(/\s/g, ''), 10)
      b = parseInt(('' + b).replace(/\s/g, ''), 10)

      if (r == null || g == null || b == null || isNaN(r) || isNaN(g) || isNaN(b)) {
        alert('Please enter numeric RGB values!')
        return
      }
      if (r < 0 || g < 0 || b < 0 || r > 255 || g > 255 || b > 255) {
        alert('RGB values must be in the range 0 to 255.')
        return
      }
      r = r / 255
      g = g / 255
      b = b / 255
      var minRGB = Math.min(r, Math.min(g, b))
      var maxRGB = Math.max(r, Math.max(g, b))

      // Black-gray-white
      if (minRGB == maxRGB) {
        computedV = minRGB
        return [0, 0, computedV]
      }
      // Colors other than black-gray-white:
      var d = r == minRGB ? g - b : b == minRGB ? r - g : b - r
      var h = r == minRGB ? 3 : b == minRGB ? 1 : 5
      computedH = 60 * (h - d / (maxRGB - minRGB))
      computedS = (maxRGB - minRGB) / maxRGB
      computedV = maxRGB
      return [computedH, computedS, computedV]
    },
    async hsvTransform (pixel, item) {
      return new Promise(async (resolve, reject) => {
        for (let i = 0; i < pixel.length; i += 4) {
          // 灰度处理
          const r = pixel[i]
          const g = pixel[i + 1]
          const b = pixel[i + 2]
          pixel[i] = r * 0.3 + g * 0.59 + b * 0.11
          pixel[i + 1] = r * 0.3 + g * 0.59 + b * 0.11
          pixel[i + 2] = r * 0.3 + g * 0.59 + b * 0.11
        }
        const hsv = new Float32Array(pixel.length / 4)
        // rgb转hsv
        for (let i = 0; i < pixel.length; i += 4) {
          const r = pixel[i]
          const g = pixel[i + 1]
          const b = pixel[i + 2]
          const tump = this.rgb2hsv(r, g, b)

          hsv[i / 4] = tump[2] * 100
        }
        const colorCanvas = this.getImageData(item)
        const ctx = colorCanvas.getContext('2d')

        var colorIndex = colorCanvas.width / 100
        // 映射关系
        for (let i = 0, j = 0; i < hsv.length; i++, j += 4) {
          const v = hsv[i]

          const cindex = Math.floor(v * colorIndex)

          var tststpixel = ctx.getImageData(cindex - 1, 1, 1, 1)
          const [r, g, b] = tststpixel.data
          pixel[j] = r
          pixel[j + 1] = g
          pixel[j + 2] = b
        }
        resolve(pixel)
      })
    },
    getImageData (item) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      var gradient = ctx.createLinearGradient(0, 0, 100, 0)
      canvas.width = 100
      canvas.height = 25
      item = _.orderBy(item, ['stop'], ['asc'])
      item.forEach((part) => {
        gradient.addColorStop(part.stop / 100, part.rgba)
      })
      ctx.fillStyle = gradient
      ctx.fillRect(0, 0, 100, 25)
      return canvas
    },
    // 初始化插槽后会丢失颜色 需恢复第一步的头发跟皮肤颜色
    recoverColor () {
      if (this.dataList['clothes']['hair'].colorInfo.activeColor !== '') {
        typeJson.colorCtrl['hair'].forEach((slot) => {
          const activeSlot = this.Model.skeleton.findSlot(slot)
          if (activeSlot) {
            const rgb = this.dataList['clothes']['hair'].colorInfo.activeColor
            activeSlot.color.r = rgb[0]
            activeSlot.color.g = rgb[1]
            activeSlot.color.b = rgb[2]
          }
        })
      }
      if (this.dataList['clothes']['skin'].colorInfo.activeColor !== '') {
        typeJson.colorCtrl['skin'].forEach((slot) => {
          const activeSlot = this.Model.skeleton.findSlot(slot)
          if (activeSlot) {
            const rgb = this.dataList['clothes']['skin'].colorInfo.activeColor
            activeSlot.color.r = rgb[0]
            activeSlot.color.g = rgb[1]
            activeSlot.color.b = rgb[2]
          }
        })
      }
    },
    /** 第一步换装逻辑 结束  */
    /** 照相馆操作  开始 */
    navClickPicture (type) {
      this.activePictureTab = type
    },
    resetPicture () {
      this.showConfirm2 = true
    },
    goAction () {
      if (this.personRect) {
        this.personContain.removeChild(this.personRect)
        this.personRect = null
      }

      this.tabMode = 'full'
      this.Model.state.clearTracks()
      this.isAction = true
      this.loadBone()
      const scale = (10 * window.fs) / this.Model.spineData.height
      this.personContain.moveX = this.personContain.x
      this.personContain.moveY = this.personContain.y
      this.personContain.y = 5 * window.fs
      this.personContain.x = this.init_data.stageWidth / 2
      this.personContain.scale.set(scale)
      this.personContain.interactive = false

      if (!localStorage.getItem('zpace_action')) {
        this.$refs.guideModal.showModal()
        localStorage.setItem('zpace_action', '1')
      }
    },
    pictureChoose (item, index) {
      if (item.type == 'bg') {
        if (this.dataList.picture[item.type].active === index) {
          this.dataList.picture[item.type].active = ''
          this.bgContain.removeChild(this.bgSprite)
          this.bgSprite = null
        } else {
          this.dataList.picture[item.type].active = index

          if (this.bgSprite) {
            this.bgSprite.texture = this.app.loader.resources[
              'bg_' + this.dataList.picture[item.type].list[index].id
            ].texture
          } else {
            this.bgSprite = new PIXI.Sprite(
              this.app.loader.resources['bg_' + this.dataList.picture[item.type].list[index].id].texture
            )

            this.bgContain.addChild(this.bgSprite)
          }
          // 背景图片尺寸大小
          const width = 750
          const height = 1000
          this.bgSprite.x = 0
          this.bgSprite.y = 0
          this.bgSprite.width = width
          this.bgSprite.height = height
          var scale = this.init_data.stageWidth / width
          this.bgSprite.scale.set(scale)
        }
      } else {
        if (this.dataList.picture[item.type].active === index && this.dataList.picture[item.type].active !== '') {
          this.Model.state.clearTrack(item.index)
          this.Model.skeleton.setToSetupPose()
          this.recoverColor()
          this.dataList.picture[item.type].active = ''
        } else {
          this.dataList.picture[item.type].active = index

          this.Model.state.setAnimation(item.index, item.name, true)

          // this.Model.skeleton.data.skins[0].attachments.forEach(item => {
          //   for (const attach in item) {
          //     if (item[attach].name === 'gloves_L_2') {
          //       const attachment = this.Model.skeleton.getAttachmentByName('gloves_L', 'gloves_L_2')
          //       console.log(attachment)
          //       attachment.region.texture = null
          //     }
          //   }
          // })
        }
      }
    },
    actionConfirm () {
      this.isAction = false
      this.personContain.interactive = true
      if (this.isActionMove) {
        this.dataList.picture['action'].active = ''
      }

      this.personContain.removeChild(this.boneContain)
      this.personContain.scale.set(this.scale)
      this.personContain.y = this.personContain.moveY
      this.personContain.x = this.personContain.moveX
    },
    actionCancel () {
      this.isAction = false
      this.personContain.interactive = true
      this.personContain.removeChild(this.boneContain)

      // 恢复大小
      this.personContain.scale.set(this.scale)
      this.personContain.y = this.personContain.moveY
      this.personContain.x = this.personContain.moveX
      if (this.dataList.picture['action'].active !== '') {
        const item = this.dataList.picture['action'].list[this.dataList.picture['action'].active]
        this.Model.state.setAnimation(item.index, item.name, true)
      } else {
        // this.Model.skeleton.setToSetupPose()
        // this.recoverColor()
        for (let i = 0; i < this.Model.skeleton.bones.length; i++) {
          const bone = this.Model.skeleton.bones[i]
          const index = this.beforeActionSpineData.findIndex(item => item.name === bone.data.name)
          if (
            index != -1
          ) {
            bone.x = this.beforeActionSpineData[index].x
            bone.y = this.beforeActionSpineData[index].y
          }
        }
      }
    },
    async exportImage () {
      if (this.personRect) this.personContain.removeChild(this.personRect)
      // const imageData = this.app.renderer.plugins.extract.pixels(this.contentContain)
      // const imageData64 = this.app.renderer.plugins.extract.base64(this.contentContain)

      this.app.render()

      const base64 = this.app.view.toDataURL('image/jpeg')
      // this.bgContain.removeChild(this.bgSprite)
      // this.bgSprite = null
      const bgWidth = 750 // 一倍屏下背景的宽度
      const bgHeight = 1000
      // 整个画布尺寸 根据dpr 不同 尺寸不一样
      const sWidth = this.app.view.clientWidth * window.devicePixelRatio
      const sHeight = this.app.view.clientHeight * window.devicePixelRatio
      // 要裁剪的图片高度
      const height = bgHeight * (sWidth / bgWidth)
      console.log(sWidth, sHeight, height)
      this.clipImage(base64, { sWidth: sWidth, sHeight: sHeight, x: 0, y: 0, width: sWidth, height: height }).then(
        (res) => {
          this.exportImg = res
          let t = setTimeout(() => {
            this.$func.convertToImage(this.$refs.result_box).then((canvas) => {
              this.resultImg = canvas.toDataURL('image/jpeg')
              this.showExportImage = true
              clearTimeout(t)
              t = null
            })
          }, 0)
        }
      )
    },
    clipImage (base64, { sWidth, sHeight, x, y, width, height }) {
      let canvas = document.createElement('canvas')
      var image = new Image()
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      image.src = base64
      image.crossOrigin = 'Anonymous'
      console.log(sWidth, sHeight, x, y, width, height)
      return new Promise((resolve, reject) => {
        image.onload = () => {
          ctx.drawImage(image, x, y, width, height, 0, 0, width, height)
          resolve(canvas.toDataURL())
          canvas = null
        }
      })
    },
    // 跳转确认弹窗
    stepConfirm ({ type }) {
      // 回到上一步
      this.resetConfirm2()
      if (this.personRect) {
        this.personContain.removeChild(this.personRect)
        this.personRect = null
      }

      this.Model.state.clearTracks()
      this.Model.skeleton.setToSetupPose()
      this.dataList[this.currentStep].bg.active = ''
      this.bgContain.removeChild(this.bgSprite)
      this.bgSprite = null
      this.dataList['picture'].action.active = ''
      this.dataList.picture.face.active = ''
      this.activePictureTab = 'action'
      this.dataList.camera.animation.active = ''
      this.activeCameraTab = 'animation'
      // 设置回颜色
      this.recoverColor()
      if (type == 0) {
        this.prevStep()
      } else if (type == 1) {
        // 跳转摄像馆
        this.goCamera()
      } else if (type == 2) {
        // 跳转摄像馆
        this.goPicture()
      }
    },
    /** 照相馆操作  结束 */
    /** 摄像馆  开始 */
    editText () {
      this.$refs.textEditorModal.showModal()
    },
    navClickCamera (type) {
      this.activeCameraTab = type
    },
    cameraChoose (item, index) {
      if (item.type == 'bg') {
        if (this.dataList.camera[item.type].active === index) {
          this.bgContain.removeChild(this.bgSprite)
          this.dataList.camera[item.type].active = ''
        } else {
          // if (this.bgSprite) this.bgContain.removeChild(this.bgSprite)
          this.dataList.camera[item.type].active = index

          // const bgSprite = new PIXI.Sprite(PIXI.Texture.from(require('./image/bainian.mp4')))
          // console.log(bgSprite)
          // const width = bgSprite.width
          // const height = bgSprite.height
          // bgSprite.x = 0
          // bgSprite.y = 0
          // bgSprite.width = this.init_data.stageWidth
          // bgSprite.height = height / (this.init_data.stageWidth / width)
          // this.app.stage.addChild(bgSprite)
          const videoTexture = PIXI.Texture.from('img/bainian.mp4')

          const videoSource = videoTexture.baseTexture.resource.source

          this.bgSprite = new PIXI.Sprite(videoTexture)
          const width = 750
          const height = 1000
          console.log(this.bgSprite)
          this.bgSprite.height = height / (width / this.init_data.stageWidth)
          this.bgSprite.width = this.init_data.stageWidth
          this.bgContain.addChild(this.bgSprite)
          setTimeout(() => {
            videoSource.play()
          }, 30)
        }
      } else {
        if (this.dataList.camera[item.type].active === index && this.dataList.camera[item.type].active !== '') {
          this.Model.state.clearTrack(item.index)
          this.Model.skeleton.setToSetupPose()
          this.recoverColor()
          this.dataList.camera[item.type].active = ''
        } else {
          this.dataList.camera[item.type].active = index
          this.Model.state.setAnimation(item.index, item.name, true)
        }
      }
    },
    openSelect (item) {
      for (const key in this.textEditData) {
        if (item != this.textEditData[key]) {
          this.textEditData[key].expand = false
        }
      }
      item.expand = !item.expand
    },
    selectText (item, index) {
      item.expand = false
      item.active = index
    },
    // 生成图片名字
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    // 上传json到七牛
    async postJson (json) {
      return new Promise((resolve, reject) => {
        json = new Blob([JSON.stringify(json)], { type: 'application/json' })
        const path = 'resources/cloud/person/'
        const sendData = {
          action: 'upload',
          bucketType: '1'
        }
        // 获取七牛上传token
        // await this.getQiniuToken(sendData)
        this.$api.qiniu.getImageTokenAdmin(sendData).then((res) => {
          if (res.status == 'ok') {
            const params = {
              token: res.data.auth_token,
              key: `${path}${this.name()}.${json.type.split('/')[1]}`
            }
            // 上传到七牛 拿到图片地址
            const observable = qiniu.upload(json, params.key, params.token)
            observable.subscribe({
              next: (result) => { },
              error: () => {
                this.$message.error('上传json失败')
                reject(new Error('上传json失败'))
              },
              complete: async (response) => {
                resolve(response.key) // 返回的路径
              }
            })
          }
        })
      })
    },
    goShare () {
      // const json = {
      //   // bgIndex: this.dataList['camera'].bg.active,
      //   // animationName: this.dataList['camera'].animation.active !== '' ? this.dataList['camera'].animation.list[this.dataList['camera'].animation.active].name : '动态_呼吸',
      //   dataList: JSON.stringify(this.dataList)
      // }
      this.postJson(this.dataList).then((res) => {
        this.$api.wow.worksSave({ work_url: res }).then((res) => {
          if (res.status == 'ok') {
            sessionStorage.setItem('showGuide', '1')
            this.$router.push({
              path: '/wowShare',
              query: {
                id: res.data.id
              }
            })
          } else {
          }
        })
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/utils';

.flip-y {
  transform: translateX();
}
.result-img {
  width: 100%;
  position: relative;
  .result_img_2 {
    position: absolute;
    bottom: 0;
    z-index: 9999;
    width: 5.8rem;
    height: 80%;
    display: block;
    opacity: 0;
    pointer-events: auto;
  }
  .top-info {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: #f2f5f7;
    .bg {
      position: relative;
      width: 4.8rem;
      height: auto;
    }
    .person {
      position: absolute;
      height: auto;
      img {
        width: auto;
        max-height: 6rem;
      }
    }
  }
  .bot-info {
    display: flex;
    align-items: center;
    padding: 0 0.2rem;
    justify-content: space-between;
    height: 1.08rem;
    span {
      font-size: 0.2rem;
      color: #333333;
    }
    .code {
      width: 0.78rem;
      height: 0.78rem;
      display: block;
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
}

.result_box {
  width: 100vw;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: -999999px;
  background-color: #ffffff;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
  .result_content {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    min-height: 10rem;
    background-color: #f2f5f7;
    overflow: hidden;
    .bg {
      position: relative;
      width: 100%;
    }
    .person {
      position: absolute;
      z-index: 10;
      img {
        width: auto;
        max-height: 9.12rem;
      }
    }
  }
  .bot-info {
    display: flex;
    align-items: center;
    padding: 0 0.32rem;
    justify-content: space-between;
    height: 1.68rem;

    span {
      font-size: 0.32rem;
      color: #333333;
    }
    .code {
      width: 1.04rem;
      height: 1.04rem;
      display: block;
    }
  }
}
.guide {
  .guide-item {
    padding: 0.6rem;
    .guide-title {
      color: #333333;
      font-size: 0.32rem;
      text-align: left;
      margin-bottom: 0.32rem;
    }
    .guide-content {
      width: 4rem;
      margin: 0 auto;
      .process-text {
        font-size: 0.24rem;
        color: #999999;
        margin: 0.24rem auto 0.32rem;
      }
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
    .guide-btn {
      display: flex;
      justify-content: center;
      .guide-next-btn {
        width: 2.16rem;
        height: 0.72rem;
        background-color: #ff7401;
        color: #ffffff;
        font-size: 0.32rem;
        text-align: center;
        line-height: 0.72rem;
        border-radius: 0.4rem;
      }
      .guide-prev-btn {
        width: 2.16rem;
        height: 0.72rem;
        background-color: #ffffff;
        border: 0.02rem solid #e5e5e5;
        color: #999999;
        font-size: 0.32rem;
        text-align: center;
        line-height: 0.72rem;
        border-radius: 0.4rem;
      }
      .guide-confirm-btn {
        width: 2.16rem;
        height: 0.72rem;
        background-color: #ff7401;
        color: #ffffff;
        font-size: 0.32rem;
        text-align: center;
        line-height: 0.72rem;
        border-radius: 0.4rem;
        margin-left: 0.32rem;
      }
    }
  }
}
.text-edit-form {
  width: 100%;
  height: 5.08rem;
  box-sizing: border-box;
  padding: 0.4rem 0.4rem 0.48rem;
  position: relative;
  .title {
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.48rem;
    text-align: left;
  }
  .close-icon {
    position: absolute;
    right: 0.4rem;
    top: 0.4rem;
    font-size: 0.28rem;
    color: #999999;
  }
  .select-item {
    position: relative;
    &:not(:last-child) {
      margin-bottom: 0.32rem;
    }
    .select-input {
      background-color: #f6f8fc;
      width: 100%;
      height: 0.88rem;
      border-radius: 0.44rem;
      font-size: 0.28rem;
      color: #666666;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 0.32rem;
      box-sizing: border-box;

      .text {
        width: 4.54rem;
        text-align: left;
      }
      span {
        color: #666666;
      }
    }

    .select-open {
      position: absolute;
      width: 100%;
      top: 1.02rem;
      left: 0;
      height: 4.2rem;
      z-index: 99;
      background: #f6f8fc;
      box-shadow: 0px 0.06rem 0.12rem rgba(161, 175, 201, 0.3);
      border-radius: 0.44rem;
      overflow: hidden;
      .jianbian {
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 0.84rem;
        background: linear-gradient(180deg, #282d40 0%, #f6f8fc 100%);
        pointer-events: none;
        z-index: 2;
      }
      .select-list::-webkit-scrollbar {
        width: 0 !important;
        height: 0 !important;
      }
      .select-list {
        overflow: auto;
        height: 4.2rem;
        box-sizing: border-box;
        padding: 0.32rem;
        .select-option {
          text-align: left;
          font-size: 0.28rem;
          margin-bottom: 0.32rem;
          color: #333333;
          &:active {
            color: #999999;
          }
        }
      }
    }
  }
}
.theme(
    @primary-color: #FF7401;
    @text-color: #333333;
    @text-color-2: #ffffff;
    @text-color-3: #9b9eab;
    @border-color: #3e4254;
    @stage-bgColor: #393e4e;
    @stage-bgColor-2: #F2F5F7;
    @nav-bgColor: #282d40;
    @tab-bgColor: #1e2230;
    @close-bgColor: #363d56;
    @button-bgColor: #ffffff;
    @button-active-color:#666666;
    @button-active-color-2:#888888;
    @disabled-color: #CCCCCC;
    @main-button-bgColor: rgba(255, 255, 255, 0.95);
    @box-shadow-color: rgba(161, 175, 201, 0.3);
) {
  .btn {
    display: block;
    color: @primary-color;
    background: @main-button-bgColor;
    box-shadow: 0px 0px 12px @box-shadow-color;
    opacity: 1;
    border-radius: 0.36rem;
    padding: 0.08rem 0.32rem;
    line-height: normal;
    i {
      line-height: normal;
    }
  }
  #wow {
    height: 100%;
    overflow: hidden;
    font-size: 0.28rem;
    background-color: @stage-bgColor;
    background-size: 100% auto;
    background-repeat: no-repeat;
    transition: all 0.3s ease;
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    &.bgColor {
      background-color: @stage-bgColor-2;
    }
    .action-nav-list::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
    }
    .jianbian {
      display: block;
      width: 1.2rem;
      height: 0.72rem;
      background: linear-gradient(90deg, rgba(40, 45, 64, 0.2) 0%, @nav-bgColor 100%);
      pointer-events: none;
    }

    .stage {
      width: 100vw;
      height: 100%;
      position: relative;
      .top {
        .left {
          position: absolute;
          top: 0.3rem;
          left: 0.24rem;
          z-index: 10;
        }
        .right {
          position: absolute;
          top: 0.3rem;
          right: 0.24rem;
          z-index: 10;
        }
        .next {
          display: block;

          text-align: center;
        }
      }
      .editor {
        width: 100vw;
        height: 100%;
        position: relative;
        background-size: 100% auto;
        background-repeat: no-repeat;
        .bot-text {
          position: absolute;
          top: 0.6rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1;
        }
        .top-text {
          position: absolute;
          top: 4.12rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 10;
        }
        #model-active {
          border: 4px solid #ffffff;
          box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
        }
        #spine {
          z-index: 2;
          height: 100%;
        }
      }
    }
    .action-tab {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100vw;
      z-index: 99;

      &.full {
        bottom: 0;
        transition: all 0.3s ease;
        z-index: 98;
      }
      &.halt {
        bottom: -3rem;
        transition: all 0.3s ease;
        z-index: 98;
      }
      &.camera {
        .main-button {
          .right {
            .action-btn {
              padding: 0;
              width: 0.64rem;
              height: 0.64rem;
              border-radius: 50%;
              justify-content: center;
            }
          }
        }
      }

      .main-button {
        display: flex;
        padding: 0 0.24rem;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        position: relative;
        .top-line {
          display: block;
          position: absolute;
          bottom: -0.4rem;
          left: 50%;
          transform: translateX(-50%);
          width: 1.16rem;
          height: 0.16rem;
          z-index: 10;
          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }
        .left {
          .random-btn {
            color: @text-color;
            height: 0.64rem;
            padding: 0.12rem 0.32rem;
            font-size: 0.28rem;

            display: flex;
            align-items: center;

            .icon {
              font-size: 0.32rem;
              margin-right: 10px;
            }
          }
        }
        .middle {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          .reset-action {
            padding: 0.14rem 0.32rem;
            font-size: 0.26rem;
            color: @text-color;
            &.disabled {
              color: @disabled-color;
              pointer-events: none;
            }
          }
        }
        .right {
          display: flex;
          .reset-action {
            padding: 0.14rem 0.32rem;
            font-size: 0.26rem;
            color: @text-color;
            &.disabled {
              color: @disabled-color;
              pointer-events: none;
            }
          }
          .action-btn {
            color: @text-color;
            display: flex;
            align-items: center;
            .icon {
              margin-right: 0.1rem;
              font-size: 0.32rem;
            }
          }

          .default-btn {
            display: block;
            text-align: center;
            color: @button-active-color;

            padding: 0.12rem 0.32rem;
            &.disabled {
              color: @disabled-color;
              pointer-events: none;
            }
          }
          .prev-btn {
            width: 0.64rem;
            height: 0.64rem;

            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            color: @button-active-color-2;
            margin-left: 0.24rem;
            padding: 0;
            i {
              font-size: 0.32rem;
            }
            &.disabled {
              color: @disabled-color;
              pointer-events: none;
            }
          }
          .next-btn {
            width: 0.64rem;
            height: 0.64rem;

            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            color: @button-active-color-2;
            margin-left: 0.24rem;
            padding: 0;
            i {
              font-size: 0.32rem;
            }
            &.disabled {
              color: @disabled-color;
              pointer-events: none;
            }
          }
        }
      }
      &.picture {
        .action-nav {
          .action-nav-list {
            justify-content: space-evenly;
            .action-nav-item {
              flex: 1;
              text-align: center;
            }
          }
        }
      }
      &.camera {
        .action-nav {
          .action-nav-list {
            justify-content: space-evenly;
            .action-nav-item {
              flex: 1;
              text-align: center;
            }
          }
        }
      }
      .action-nav {
        width: 100%;
        background-color: @nav-bgColor;
        position: relative;
        border-radius: 0.16rem 0.16rem 0px 0px;
        overflow: hidden;
        height: 0.72rem;
        .jianbian {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 9;
        }
        .action-nav-list {
          display: flex;
          color: @text-color-2;
          overflow-x: scroll;
          overflow-y: hidden;
          position: relative;
          padding-bottom: 50px;
          .action-nav-item {
            padding: 0.14rem 0.4rem;
            line-height: 1;
            &.active {
              color: @primary-color;
            }
            span {
              font-size: 0.44rem;
            }
          }
        }
      }
      .tab-list {
        background-color: @tab-bgColor;

        .tab-item {
          min-height: 4.48rem;
          position: relative;
          &.skin {
            .color-list::-webkit-scrollbar {
              width: 0 !important;
              height: 0 !important;
            }
            .color-list {
              height: 3.5rem;
            }
          }
          .color-list {
            padding: 0.32rem 0.64rem 0.62rem;
            height: 4.48rem;
            overflow: auto;
            box-sizing: border-box;
            .color-wrapper {
              display: flex;
              flex-wrap: wrap;
            }
            &_title {
              color: @text-color-3;
              font-size: 0.24rem;
              margin-bottom: 0.3rem;
              line-height: 0.36rem;
            }
            &_slide {
              &:not(:last-child) {
                margin-bottom: 0.46rem;
              }
              .color-pick {
                width: 100%;
                height: 0.16rem;
                border-radius: 0.06rem;
                position: relative;
                &.color-hue {
                  background: linear-gradient(
                    76deg,
                    #ff3700 0%,
                    #fff800 19%,
                    #00ff07 37%,
                    #00c8ff 54%,
                    #3200ff 77%,
                    #ff003c 100%
                  );
                }
                &.color-saturation {
                  background: linear-gradient(76deg, #857b7b 0%, #ff0000 100%);
                }
                &.color-brightness {
                  background: linear-gradient(76deg, #000000 0%, #f5f5f5 100%);
                }
                .slider {
                  width: 0.48rem;
                  height: 0.48rem;
                  border-radius: 50%;
                  background-color: @button-bgColor;
                  box-shadow: 0px 0px 12px rgba(161, 175, 201, 0.4);
                  position: absolute;
                  left: 0;
                  top: 50%;
                  transform: translate(-50%, -50%);
                }
              }
            }

            .color-item {
              height: 0.92rem;
              width: 0.92rem;
              border-radius: 50%;
              margin-bottom: 0.4rem;
              margin-top: 0.08rem;
              border: 2px solid @nav-bgColor;
              &.default {
                width: 0.92rem;
                height: 0.92rem;
                font-size: 0.24rem;

                color: @text-color-3;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: @nav-bgColor;
              }
              &.active {
                border: 2px solid @primary-color;
              }

              img {
                width: 100%;
                height: auto;
                display: block;
              }
              &:not(:nth-of-type(5n)) {
                margin-right: 0.4rem;
              }
              .title {
                color: @text-color-3;
                font-size: 0.24rem;
                margin-bottom: 0.3rem;
                line-height: 0.36rem;
              }
            }
          }
          .bot-btn {
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
            padding: 0.22rem 0.24rem 0.2rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .info-text {
              font-size: 0.28rem;
              color: @text-color-2;
            }
            .btn-list {
              display: flex;
              .btn {
                margin-left: 0.24rem;
                color: @button-active-color;
              }
              .color-confirm {
                background-color: @primary-color;
                color: @button-bgColor;
              }
            }
          }
          .title {
            padding-left: 0.32rem;
            font-size: 0.24rem;
            color: @text-color-3;
            height: 0.72rem;
            line-height: 0.72rem;
            background-color: @nav-bgColor;
            .setOnePx(@border-color);
          }
          .action-list::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
          }
          &.my {
            .action-list {
              height: 3.74rem;
              .action-item {
                .cover {
                  border: none;
                }
              }
            }
          }
          &.action,
          &.bg,
          &.animation {
            .action-list {
              .action-item {
                .cover {
                  height: 2.14rem;
                }
              }
            }
          }
          .action-list {
            height: 4.48rem;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 0.24rem 0.24rem 0;
            box-sizing: border-box;
            .action-item {
              width: 1.6rem;
              background-color: @nav-bgColor;
              position: relative;
              border-radius: 0.16rem;
              box-sizing: border-box;
              float: left;

              &:not(:nth-of-type(4n)) {
                margin-right: 0.2rem;
              }

              margin-bottom: 0.24rem;
              .cover {
                width: 1.6rem;
                height: 1.6rem;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                box-sizing: border-box;
                border: 1px solid @nav-bgColor;
                border-radius: 0.16rem;
                padding: 0.12rem;
                &.active {
                  border: 1px solid @primary-color;
                }
                img {
                  display: block;
                  width: 100%;
                  height: auto;
                }
              }
              .name {
                height: 0.48rem;
                line-height: 0.48rem;
                text-align: center;
                font-size: 0.2rem;
                color: @text-color-3;
                .setOnePx(@border-color);
              }
              .delete-btn {
                display: block;
                text-align: center;
                position: absolute;
                top: -0.08rem;
                right: -0.08rem;
                width: 0.32rem;
                height: 0.32rem;
                line-height: 0.32rem;
                border-radius: 50%;
                background-color: @close-bgColor;
                color: @text-color-3;
                z-index: 10;
                display: flex;
                justify-content: center;
                align-items: center;
                .icon-icon_close_8 {
                  display: block;
                  font-size: 0.32rem;
                  transform: scale(0.5);
                }
              }
            }
          }
          .color-btn {
            position: absolute;
            bottom: 0.34rem;
            left: 50%;
            transform: translateX(-50%);
            padding: 0.14rem 0.78rem;
            .icon {
              font-size: 0.44rem;
              color: @text-color;
              line-height: 1;
            }
          }
        }
      }
      .color-select-tab {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 5.2rem;
        background-color: @tab-bgColor;
        border-radius: 0.16rem 0.16rem 0px 0px;
        z-index: 10;
        &.action {
          border-radius: 0;
          .bot-btn {
            border-top: none;
            height: 100%;
          }
        }
        .color-list {
          padding: 0.32rem 0.64rem 0.62rem;
          height: 5.2rem;
          overflow: auto;
          box-sizing: border-box;

          .color-wrapper {
            display: flex;
            flex-wrap: wrap;
          }
          &_slide {
            &:not(:last-child) {
              margin-bottom: 0.48rem;
            }
            .title {
              color: @text-color-3;
              font-size: 0.24rem;
              margin-bottom: 0.3rem;
              line-height: 0.36rem;
            }
            .color-pick {
              width: 100%;
              height: 0.16rem;
              border-radius: 0.06rem;
              position: relative;
              &.color-hue {
                background: linear-gradient(
                  76deg,
                  #ff3700 0%,
                  #fff800 19%,
                  #00ff07 37%,
                  #00c8ff 54%,
                  #3200ff 77%,
                  #ff003c 100%
                );
              }
              &.color-saturation {
                background: linear-gradient(76deg, #857b7b 0%, #ff0000 100%);
              }
              &.color-brightness {
                background: linear-gradient(76deg, #000000 0%, #f5f5f5 100%);
              }
              .slider {
                width: 0.48rem;
                height: 0.48rem;
                border-radius: 50%;
                background-color: @button-bgColor;
                box-shadow: 0px 0px 12px rgba(161, 175, 201, 0.4);
                position: absolute;
                left: 0;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }

          .color-item {
            height: 0.92rem;
            width: 0.92rem;
            border-radius: 50%;
            margin-bottom: 0.4rem;
            margin-top: 0.08rem;
            border: 2px solid @nav-bgColor;
            &.default {
              height: 0.92rem;
              width: 0.92rem;
              font-size: 0.24rem;
              color: @text-color-3;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: @nav-bgColor;
            }
            &.active {
              border: 2px solid @primary-color;
            }

            img {
              width: 100%;
              height: auto;
              display: block;
            }
            &:not(:nth-of-type(5n)) {
              margin-right: 0.4rem;
            }
            .title {
              color: @text-color-3;
              font-size: 0.24rem;
              margin-bottom: 0.3rem;
              line-height: 0.36rem;
            }
          }
        }
        .bot-btn {
          position: absolute;
          width: 100%;

          bottom: 0;
          left: 0;
          padding: 0.22rem 0.24rem 0.2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: @nav-bgColor;
          .info-text {
            font-size: 0.28rem;
            color: @text-color-2;
          }
          .btn-list {
            display: flex;
            .btn {
              margin-left: 0.24rem;
              color: @button-active-color;
            }
            .color-confirm {
              background-color: @primary-color;
              color: @button-bgColor;
            }
          }
        }
      }
    }
  }
  .loading-page {
    height: 100vh;
    width: 100vw;
    background-color: @stage-bgColor;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 99999;
    left: 0;
    right: 0;
    .loading-gif {
      width: 3.6rem;
      height: 3.6rem;
      img {
        display: play;
        width: 100%;
        height: auto;
      }
    }
  }
}
.dark-theme {
  height: 100%;
  .theme();
}
</style>
